webpackJsonp([25],{

/***/ 1004:
/***/ (function(module, exports) {

module.exports = "\r\n<my-app-sidenav [hidden]=\"!logedin\"></my-app-sidenav>\r\n\r\n<section [hidden]=\"!logedin\" id=\"page-container\" class=\"app-page-container\">\r\n  <my-app-header ></my-app-header>\r\n\r\n  <div class=\"app-content-wrapper\">\r\n    <div class=\"app-content\">\r\n      <div class=\"full-height\">\r\n        <router-outlet></router-outlet>\r\n      </div>\r\n    </div>\r\n\r\n    <my-app-footer></my-app-footer>\r\n  </div>\r\n</section>\r\n\r\n<!--<my-app-customizer></my-app-customizer>-->\r\n\r\n<my-app-search-overlay></my-app-search-overlay>\r\n"

/***/ }),

/***/ 1010:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EChartsDirective; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_echarts__ = __webpack_require__(450);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_echarts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_echarts__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_echarts_theme_macarons__ = __webpack_require__(1300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_echarts_theme_macarons___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_echarts_theme_macarons__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__layout_layout_service__ = __webpack_require__(110);





var EChartsDirective = /** @class */ (function () {
    function EChartsDirective(el, layoutService) {
        var _this = this;
        this.layoutService = layoutService;
        this.resizeChart = function (state) {
            // console.log('state: ' + state)
            setTimeout(function () {
                if (_this.myChart) {
                    //this.myChart.resize();
                    _this.myChart.dispose();
                    _this.myChart = null;
                    _this.myChart = __WEBPACK_IMPORTED_MODULE_2_echarts___default.a.init(_this.el.nativeElement, 'macarons');
                    if (!_this.EChartsOptions) {
                        return;
                    }
                    _this.myChart.setOption(_this.EChartsOptions);
                }
            }, 0);
        };
        this.el = el;
        this.subscription = layoutService.echartsState$.subscribe(function (state) {
            _this.resizeChart(state);
        });
    }
    EChartsDirective.prototype.ngAfterViewInit = function () {
        var _this = this;
        setTimeout(function () {
            _this.myChart = __WEBPACK_IMPORTED_MODULE_2_echarts___default.a.init(_this.el.nativeElement, 'macarons');
            if (!_this.EChartsOptions) {
                return;
            }
            _this.myChart.setOption(_this.EChartsOptions);
        }, 0);
    };
    EChartsDirective.prototype.ngOnDestroy = function () {
        if (this.myChart) {
            this.myChart.dispose();
            this.myChart = null; // https://bitbucket.org/iarouse/angular-material/commits/5eec2667b5496edfa1cc0896333b83e188a35676
        }
    };
    EChartsDirective.prototype.onResize = function () {
        this.resizeChart(true);
    };
    __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __decorate */]([
        Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"])(),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __metadata */]("design:type", Object)
    ], EChartsDirective.prototype, "EChartsOptions", void 0);
    __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __decorate */]([
        Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["HostListener"])('window:resize'),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __metadata */]("design:type", Function),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __metadata */]("design:paramtypes", []),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __metadata */]("design:returntype", void 0)
    ], EChartsDirective.prototype, "onResize", null);
    EChartsDirective = __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __decorate */]([
        Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Directive"])({ selector: '[myECharts]' }),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __metadata */]("design:paramtypes", [__WEBPACK_IMPORTED_MODULE_1__angular_core__["ElementRef"], __WEBPACK_IMPORTED_MODULE_4__layout_layout_service__["a" /* LayoutService */]])
    ], EChartsDirective);
    return EChartsDirective;
}());



/***/ }),

/***/ 110:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LayoutService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs_Subject__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs_Subject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_rxjs_Subject__);



var LayoutService = /** @class */ (function () {
    function LayoutService() {
        this.preloaderStateSource = new __WEBPACK_IMPORTED_MODULE_2_rxjs_Subject__["Subject"]();
        this.preloaderState$ = this.preloaderStateSource.asObservable();
        this.searchOverlaySource = new __WEBPACK_IMPORTED_MODULE_2_rxjs_Subject__["Subject"]();
        this.searchOverlayState$ = this.searchOverlaySource.asObservable();
        this.echartsSource = new __WEBPACK_IMPORTED_MODULE_2_rxjs_Subject__["Subject"]();
        this.echartsState$ = this.echartsSource.asObservable();
    }
    LayoutService.prototype.updatePreloaderState = function (state) {
        // console.log('preloader state: ' + state)
        this.preloaderStateSource.next(state);
    };
    LayoutService.prototype.updateSearchOverlayState = function (state) {
        // console.log('overlay state: ' + state)
        this.searchOverlaySource.next(state);
    };
    LayoutService.prototype.updateEChartsState = function (state) {
        // console.log('echarts state: ' + state)
        this.echartsSource.next(state);
    };
    LayoutService = __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __decorate */]([
        Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Injectable"])()
    ], LayoutService);
    return LayoutService;
}());



/***/ }),

/***/ 121:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Api; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ApplicationVariables; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_http__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_router__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__angular_material__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__angular_core__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_ng2_toastr__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_ng2_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_ng2_toastr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_rxjs_add_operator_map__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_rxjs_add_operator_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_rxjs_add_operator_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_rxjs__ = __webpack_require__(523);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_rxjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_rxjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_angular2_csv__ = __webpack_require__(530);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_angular2_csv___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_angular2_csv__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_angular2_json2csv__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_angular2_json2csv___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_angular2_json2csv__);











var Api = /** @class */ (function () {
    // todo Phone number length after mask is 14;
    function Api(http, snackBar, router, toastr, csvService
    //private vcr:ViewContainerRef
    // ,private layoutService:LayoutService
    ) {
        this.http = http;
        this.snackBar = snackBar;
        this.router = router;
        this.toastr = toastr;
        this.csvService = csvService;
        this.url = null;
        // adpUrl:string = APPCONFIG.ADP_API_BASE_URL;
        this.currentURL = new __WEBPACK_IMPORTED_MODULE_8_rxjs__["BehaviorSubject"](null);
        // getCurentUrl = this.currentURL.asObservable();
        // starting badge functionality
        this.isFirstLogin = new __WEBPACK_IMPORTED_MODULE_8_rxjs__["BehaviorSubject"](null);
        this.getIfFirstLogin = this.isFirstLogin.asObservable();
        this.PHONE_MASKNA = ['+', /\d/, ' ', '(', /[0-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
        this.PHONE_MASKPK = ['+', /\d/, /\d/, ' ', '(', /[0-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
        this.PHONE_MASK = ['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
        this.countryCodeMask = ['+', /\d/, /\d/, /\d/];
        this.shippingCostPriceMask = [/\d/, /\d/, /\d/];
        // this.toastr.setRootViewContainerRef(vcr);
    }
    Api.prototype.ngOnInit = function () {
        //this.getURL();
    };
    Api.prototype.isloggedInUserAdmin = function () {
        this.getADPCustomer();
        return this.getADPCustomer().roleId === 1;
    };
    // setURL(){
    //     // todo  May 28 2019  by NH AR and NR Once
    //     //  On login the response object will bring the end points [rtapi,dtapi,billingapi] that needs to set for url  of user
    //     // inside set url method rettrieve the end points and set in this.url
    //     console.log("setURL.countryCode 123 --- ", localStorage.getItem("countryCode"));
    //
    //     if(localStorage.getItem('countryCode') == undefined){
    //         console.log('countryCode is undefined', localStorage.getItem('countryCode'));
    //         this.url = APPCONFIG.LOCAL_DTAPI_PK;
    //         this.server_region = 'NA';
    //         this.PHONE_MASK1=this.PHONE_MASKNA;
    //     }
    //     else if(localStorage.getItem("countryCode") === "+92") {
    //         this.url = APPCONFIG [APPCONFIG.ENVIRONMENT + "_DTAPI_PK"];
    //             this.server_region = 'PK';
    //         this.PHONE_MASK1=this.PHONE_MASKPK;
    //
    //     }
    //     else if(localStorage.getItem("countryCode") === "+1") {
    //         this.url = APPCONFIG [APPCONFIG.ENVIRONMENT + "_DTAPI_NA"];
    //         this.server_region = 'NA';
    //         this.PHONE_MASK1=this.PHONE_MASKNA;
    //
    //     }
    //     else
    //     {
    //         this.url = APPCONFIG.LOCAL_DTAPI_PK;
    //         console.log("ELSE OPTION RUNNING---------------------->", this.url)
    //         this.server_region = 'NA';
    //         this.PHONE_MASK1=this.PHONE_MASKNA;
    //
    //
    //     }
    //
    //
    //     console.log("setURl.this.url ---- ", this.url, "----");
    // }
    Api.prototype.setUrls = function () {
        if (__WEBPACK_IMPORTED_MODULE_5__config__["a" /* APPCONFIG */].ENVIRONMENT == "COMMERCIAL" || __WEBPACK_IMPORTED_MODULE_5__config__["a" /* APPCONFIG */].ENVIRONMENT == "DEV") {
            this.url = localStorage.getItem('dtApiURL') + "api/v1";
            console.log("IF OPTION RUNNING---------------------->", this.url);
        }
        else {
            this.url = "http://localhost:8089/api/v1";
            console.log("ELSE OPTION RUNNING---------------------->", this.url);
        }
    };
    Api.prototype.setIfFirstLogin = function (firstLoginState) {
        this.isFirstLogin.next(firstLoginState);
    };
    // setCurrentURL(currentURL){
    // this.currentURL.next(currentURL)
    //     // console.log("curent urls", this.get)
    // }
    Api.prototype.get = function (endpoint, params, reqOpts) {
        this.setUrls(); /*SET URL According to the user Country */
        if (!reqOpts) {
            reqOpts = new __WEBPACK_IMPORTED_MODULE_1__angular_http__["e" /* RequestOptions */]();
        }
        if (this.shouldToAddToken(endpoint)) {
            var headers = new __WEBPACK_IMPORTED_MODULE_1__angular_http__["a" /* Headers */]();
            headers.append("token", this.getTokenFromLocalStorage());
            reqOpts = new __WEBPACK_IMPORTED_MODULE_1__angular_http__["e" /* RequestOptions */]({ headers: headers });
        }
        // Support easy query params for GET requests
        if (params) {
            reqOpts.params = new URLSearchParams();
            for (var k in params) {
                reqOpts.params.set(k, params[k]);
            }
        }
        return this.http.get(this.url + '/' + endpoint, reqOpts);
        //
        // if(this.getCountryCode() === "+92")
        //   return this.http.get(APPCONFIG.DT_API_PK + '/' + endpoint, reqOpts);
        // else
        //   return this.http.get(APPCONFIG.DT_API_NA + '/' +endpoint, reqOpts);
    };
    // POST
    Api.prototype.post = function (endpoint, body, reqOpts) {
        this.setUrls(); /*SET URL According to the user Country */
        if (this.shouldToAddToken(endpoint)) {
            var headers = new __WEBPACK_IMPORTED_MODULE_1__angular_http__["a" /* Headers */]();
            headers.append("token", this.getTokenFromLocalStorage());
            reqOpts = new __WEBPACK_IMPORTED_MODULE_1__angular_http__["e" /* RequestOptions */]({ headers: headers });
        }
        //
        // if(this.getCountryCode() === "+92")
        //     return this.http.post(APPCONFIG.DT_API_PK + '/' + endpoint, body, reqOpts);
        // else
        //     return this.http.post(APPCONFIG.DT_API_NA + '/' +endpoint, body, reqOpts);
        return this.http.post(this.url + '/' + endpoint, body, reqOpts);
    };
    Api.prototype.postImage = function (endpoint, body, reqOpts) {
        var url = localStorage.getItem('imageUploderURL');
        url = url.split('upload.php')[0];
        return this.http.post(url + endpoint + this.getTokenFromLocalStorage(), body, reqOpts);
    };
    Api.prototype.imageUploaderPost = function (endpoint, body, productId) {
        var url = __WEBPACK_IMPORTED_MODULE_5__config__["a" /* APPCONFIG */].java_image_uploader_url;
        console.log("Image uploadwr fuction called url : " + url + endpoint + body + productId);
        var headers = new __WEBPACK_IMPORTED_MODULE_1__angular_http__["a" /* Headers */]();
        // headers.append('Content-Type', 'multipart/form-data');
        // headers.append('Accept', 'application/json');
        headers.append("token", this.getTokenFromLocalStorage());
        headers.append("productCode", productId);
        headers.append("size", __WEBPACK_IMPORTED_MODULE_5__config__["a" /* APPCONFIG */].imageCutterSizes);
        headers.append("countryAbbrivation", localStorage.getItem('countryAbbrivation'));
        var reqOpts = new __WEBPACK_IMPORTED_MODULE_1__angular_http__["e" /* RequestOptions */]({ headers: headers });
        return this.http.post(url + endpoint, body, reqOpts);
    };
    Api.prototype.brandImageUploaderPost = function (endpoint, body, brandImageName, size) {
        var url = __WEBPACK_IMPORTED_MODULE_5__config__["a" /* APPCONFIG */].java_image_uploader_url;
        console.log("Image uploadwr fuction called url : " + url + endpoint + body + brandImageName);
        var headers = new __WEBPACK_IMPORTED_MODULE_1__angular_http__["a" /* Headers */]();
        // headers.append('Content-Type', 'multipart/form-data');
        // headers.append('Accept', 'application/json');
        headers.append("token", this.getTokenFromLocalStorage());
        headers.append("brandImageName", brandImageName);
        headers.append("size", size);
        headers.append("countryAbbrivation", localStorage.getItem('countryAbbrivation'));
        var reqOpts = new __WEBPACK_IMPORTED_MODULE_1__angular_http__["e" /* RequestOptions */]({ headers: headers });
        return this.http.post(url + endpoint, body, reqOpts);
    };
    Api.prototype.tempImageUploaderPost = function (endpoint, body) {
        var url = __WEBPACK_IMPORTED_MODULE_5__config__["a" /* APPCONFIG */].java_image_uploader_url;
        console.log("Image uploadwr fuction called url : " + url + endpoint + body);
        var headers = new __WEBPACK_IMPORTED_MODULE_1__angular_http__["a" /* Headers */]();
        // headers.append('Content-Type', 'multipart/form-data');
        // headers.append('Accept', 'application/json');
        headers.append("token", this.getTokenFromLocalStorage());
        // headers.append("productCode",productId);
        // headers.append("size",APPCONFIG.imageCutterSizes);
        headers.append("countryAbbrivation", localStorage.getItem('countryAbbrivation'));
        var reqOpts = new __WEBPACK_IMPORTED_MODULE_1__angular_http__["e" /* RequestOptions */]({ headers: headers });
        return this.http.post(url + endpoint, body, reqOpts);
    };
    Api.prototype.postResetPassword = function (endpoint, body, reqOpts) {
        // this.setUrls() /*SET URL According to the user Country */
        var url = __WEBPACK_IMPORTED_MODULE_5__config__["a" /* APPCONFIG */].ApiURL_dt;
        if (this.shouldToAddToken(endpoint)) {
            var headers = new __WEBPACK_IMPORTED_MODULE_1__angular_http__["a" /* Headers */]();
            headers.append("token", this.getTokenFromLocalStorage());
            reqOpts = new __WEBPACK_IMPORTED_MODULE_1__angular_http__["e" /* RequestOptions */]({ headers: headers });
        }
        //
        // if(this.getCountryCode() === "+92")
        //     return this.http.post(APPCONFIG.DT_API_PK + '/' + endpoint, body, reqOpts);
        // else
        //     return this.http.post(APPCONFIG.DT_API_NA + '/' +endpoint, body, reqOpts);
        return this.http.post(url + '/' + endpoint, body, reqOpts);
    };
    Api.prototype.loginRA = function (endpoint, body, reqOpts) {
        return this.http.post(__WEBPACK_IMPORTED_MODULE_5__config__["a" /* APPCONFIG */][__WEBPACK_IMPORTED_MODULE_5__config__["a" /* APPCONFIG */].ENVIRONMENT + "_RA_SERVICE"] + '/' + endpoint, body, reqOpts);
    };
    Api.prototype.userAvailabilityRA = function (endpoint, body, reqOpts) {
        return this.http.post(__WEBPACK_IMPORTED_MODULE_5__config__["a" /* APPCONFIG */][__WEBPACK_IMPORTED_MODULE_5__config__["a" /* APPCONFIG */].ENVIRONMENT + "_RA_SERVICE"] + '/' + endpoint, reqOpts, { params: body });
    };
    Api.prototype.getCountryCodeRA = function (endpoint, body, reqOpts) {
        return this.http.get(__WEBPACK_IMPORTED_MODULE_5__config__["a" /* APPCONFIG */][__WEBPACK_IMPORTED_MODULE_5__config__["a" /* APPCONFIG */].ENVIRONMENT + "_RA_SERVICE"] + '/' + endpoint, { params: body });
    };
    Api.prototype.getCountryListRA = function (endpoint, body, reqOpts) {
        return this.http.get(__WEBPACK_IMPORTED_MODULE_5__config__["a" /* APPCONFIG */][__WEBPACK_IMPORTED_MODULE_5__config__["a" /* APPCONFIG */].ENVIRONMENT + "_RA_SERVICE"] + '/' + endpoint);
    };
    Api.prototype.registerUserRA = function (endpoint, body, reqOpts) {
        return this.http.post(__WEBPACK_IMPORTED_MODULE_5__config__["a" /* APPCONFIG */][__WEBPACK_IMPORTED_MODULE_5__config__["a" /* APPCONFIG */].ENVIRONMENT + "_RA_SERVICE"] + '/' + endpoint, body, reqOpts);
    };
    Api.prototype.activateRA = function (endpoint, body, reqOpts) {
        return this.http.post(__WEBPACK_IMPORTED_MODULE_5__config__["a" /* APPCONFIG */][__WEBPACK_IMPORTED_MODULE_5__config__["a" /* APPCONFIG */].ENVIRONMENT + "_RA_SERVICE"] + '/' + endpoint, body, reqOpts);
    };
    Api.prototype.postRA = function (endpoint, body, reqOpts) {
        return this.http.post(__WEBPACK_IMPORTED_MODULE_5__config__["a" /* APPCONFIG */][__WEBPACK_IMPORTED_MODULE_5__config__["a" /* APPCONFIG */].ENVIRONMENT + "_RA_SERVICE"] + '/api/v1/' + endpoint, body, reqOpts);
    };
    Api.prototype.getRA = function (endpoint, body, reqOpts) {
        return this.http.get(__WEBPACK_IMPORTED_MODULE_5__config__["a" /* APPCONFIG */][__WEBPACK_IMPORTED_MODULE_5__config__["a" /* APPCONFIG */].ENVIRONMENT + "_RA_SERVICE"] + '/api/v1/' + endpoint);
    };
    Api.prototype.put = function (endpoint, body, reqOpts) {
        this.setUrls(); /*SET URL According to the user Country */
        var headers = new __WEBPACK_IMPORTED_MODULE_1__angular_http__["a" /* Headers */]();
        headers.append("token", this.getTokenFromLocalStorage());
        reqOpts = new __WEBPACK_IMPORTED_MODULE_1__angular_http__["e" /* RequestOptions */]({ headers: headers });
        // if(this.getCountryCode() === "+92")
        //     return this.http.put(APPCONFIG.DT_API_PK + '/' + endpoint, body, reqOpts);
        // else
        //     return this.http.put(APPCONFIG.DT_API_NA + '/' +endpoint, body, reqOpts);
        return this.http.put(this.url + '/' + endpoint, body, reqOpts);
    };
    Api.prototype.delete = function (endpoint, reqOpts) {
        this.setUrls(); /*SET URL According to the user Country */
        var headers = new __WEBPACK_IMPORTED_MODULE_1__angular_http__["a" /* Headers */]();
        headers.append("token", this.getTokenFromLocalStorage());
        reqOpts = new __WEBPACK_IMPORTED_MODULE_1__angular_http__["e" /* RequestOptions */]({ headers: headers });
        /*if(this.getCountryCode() === "+92")
            return this.http.delete(APPCONFIG.DT_API_PK + '/' + endpoint, reqOpts);
        else
            return this.http.delete(APPCONFIG.DT_API_NA + '/' +endpoint, reqOpts);*/
        return this.http.delete(this.url + '/' + endpoint, reqOpts);
    };
    Api.prototype.patch = function (endpoint, body, reqOpts) {
        this.setUrls(); /*SET URL According to the user Country */
        /* if(this.getCountryCode() === "+92")
             return this.http.put(APPCONFIG.DT_API_PK + '/' + endpoint, body, reqOpts);
         else
             return this.http.put(APPCONFIG.DT_API_NA + '/' +endpoint, body, reqOpts);*/
        return this.http.put(this.url + '/' + endpoint, body, reqOpts);
    };
    Api.prototype.postADP = function (endpoint, body, reqOpts) {
        if (this.getCountryCode() === "+92")
            return this.http.post(__WEBPACK_IMPORTED_MODULE_5__config__["a" /* APPCONFIG */][__WEBPACK_IMPORTED_MODULE_5__config__["a" /* APPCONFIG */].ENVIRONMENT + "_RTAPI_PK"] + '/' + endpoint, body, reqOpts);
        else
            return this.http.post(__WEBPACK_IMPORTED_MODULE_5__config__["a" /* APPCONFIG */][__WEBPACK_IMPORTED_MODULE_5__config__["a" /* APPCONFIG */].ENVIRONMENT + "_RTAPI_NA"] + '/' + endpoint, body, reqOpts);
    };
    Api.prototype.getADP = function (endpoint, params, reqOpts) {
        if (!reqOpts) {
            reqOpts = new __WEBPACK_IMPORTED_MODULE_1__angular_http__["e" /* RequestOptions */]();
        }
        // Support easy query params for GET requests
        if (params) {
            reqOpts.params = new URLSearchParams();
            for (var k in params) {
                reqOpts.params.set(k, params[k]);
            }
        }
        if (this.getCountryCode() === "+92")
            return this.http.get(__WEBPACK_IMPORTED_MODULE_5__config__["a" /* APPCONFIG */][__WEBPACK_IMPORTED_MODULE_5__config__["a" /* APPCONFIG */].ENVIRONMENT + "_RTAPI_PK"] + '/' + endpoint, reqOpts);
        else
            return this.http.get(__WEBPACK_IMPORTED_MODULE_5__config__["a" /* APPCONFIG */][__WEBPACK_IMPORTED_MODULE_5__config__["a" /* APPCONFIG */].ENVIRONMENT + "_RTAPI_NA"] + '/' + endpoint, reqOpts);
        // return this.http.get(this.adpUrl + '/' + endpoint, reqOpts);
    };
    Api.prototype.getTokenFromLocalStorage = function () {
        var user = JSON.parse(localStorage.getItem('currentUser'));
        //console.log("user",user.authToken);
        if (user) {
            return user.authToken;
        }
        else {
            return "";
        }
    };
    Api.prototype.tokenExpiredLogout = function () {
        this.snackBar.open("You Are Logged Out", "", {
            duration: 5000
        });
        this.router.navigate(['/extra/login']);
    };
    Api.prototype.gotoLogOut = function () {
        var _this = this;
        // this.api.activateLoader();
        this.get("user/logout").subscribe(function (res) {
            localStorage.removeItem('currentUser');
            localStorage.removeItem('countryCode');
            localStorage.removeItem('billingCurrency');
            localStorage.removeItem('dtApiURL');
            localStorage.removeItem('billingApiUrl');
            localStorage.removeItem('imageUploderURL');
            localStorage.removeItem('imageStatsURL');
            localStorage.removeItem('countryAbbrivation');
            localStorage.removeItem(__WEBPACK_IMPORTED_MODULE_5__config__["a" /* APPCONFIG */].prefix + 'isLoggedIn');
            _this.router.navigate(['/extra/login']);
            // this.api.hideLoader();
        }, function (err) {
            console.log(err);
            //if (err.status == 401) {
            localStorage.removeItem('currentUser');
            localStorage.removeItem('countryCode');
            localStorage.removeItem('billingCurrency');
            localStorage.removeItem('dtApiURL');
            localStorage.removeItem('billingApiUrl');
            localStorage.removeItem('imageUploderURL');
            localStorage.removeItem('imageStatsURL');
            localStorage.removeItem('countryAbbrivation');
            localStorage.removeItem(__WEBPACK_IMPORTED_MODULE_5__config__["a" /* APPCONFIG */].prefix + 'isLoggedIn');
            _this.router.navigate(['/extra/login']);
            // this.api.hideLoader();
            // }
        });
    };
    Api.prototype.toastMsg = function (msg, action) {
        // msg=msg.toLowerCase();
        // msg=msg.charAt(0).toUpperCase()+msg.slice(1);
        this.snackBar.open(msg, action, {
            duration: 3500
        });
    };
    Api.prototype.showToastSuccess = function (msg) {
        this.toastr.success(msg, 'Success!');
    };
    Api.prototype.showToastError = function (msg) {
        this.toastr.error(msg, 'Oops!');
    };
    Api.prototype.showToastWarning = function (msg) {
        this.toastr.warning(msg, 'Alert!');
    };
    Api.prototype.showToastInfo = function (msg) {
        this.toastr.info(msg);
    };
    Api.prototype.showCustom = function () {
        this.toastr.custom('<span style="color: red">Message in red.</span>', null, { enableHTML: true });
    };
    Api.prototype.getADPCustomerUUID = function () {
        var user = JSON.parse(localStorage.getItem('currentUser'));
        if (user && user.adpCustomerInfo) {
            return user.adpCustomerInfo.uuid;
        }
        else {
            return "";
        }
    };
    Api.prototype.getADPCustomer = function () {
        var user = JSON.parse(localStorage.getItem('currentUser'));
        if (user) {
            return user;
        }
        else {
            return "";
        }
    };
    Api.prototype.getADPCustomerBillingCurrency = function () {
        var billingCurrency = localStorage.getItem('billingCurrency');
        if (billingCurrency) {
            return billingCurrency;
        }
        else {
            return "";
        }
    };
    Api.prototype.getADPCustomerTrialDays = function () {
        var user = JSON.parse(localStorage.getItem('currentUser'));
        if (user && user.adpCustomerInfo) {
            return user.adpCustomerInfo.trialDays;
        }
        else {
            return 0;
        }
    };
    Api.prototype.getADPCustomerType = function () {
        var customerType = localStorage.getItem("customerType");
        if (customerType) {
            return customerType;
        }
        else {
            return "";
        }
    };
    // activateLoader() {
    //   this.layoutService.updatePreloaderState('active');
    // }
    // hideLoader() {
    //   this.layoutService.updatePreloaderState('hide');
    // }
    Api.prototype.downloadSaveFile = function (filename, text) {
        var dat = JSON.parse(text);
        //  var pom = document.createElement('a');
        // pom.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(text));
        // pom.setAttribute('download', filename);
        // if (document.createEvent) {
        //     var event = document.createEvent('MouseEvents');
        //     event.initEvent('click', true, true);
        //     pom.dispatchEvent(event);
        // }
        // else {
        //     pom.click();
        // }
        var options = {
            fieldSeparator: ',',
            quoteStrings: '"',
            decimalseparator: '.',
            showLabels: true,
            showTitle: false,
            useBom: true
        };
        // var finaldat = dat.data.unshift(dat.fields);
        // const data = ;
        // const headers = text.fields
        new __WEBPACK_IMPORTED_MODULE_9_angular2_csv__["Angular2Csv"](dat.data, filename.split(".")[0], { headers: (dat.fields) });
        // this.csvService.download(dat.data,'My Report');
        //downloadCsv(data, headers);
        //var blob = new Blob([text], {type: "text/csv;charset=utf-8"});
        // var blob = new Blob([text], {type: "text/plain"});
        // var href = window.URL.createObjectURL(blob);
        // var link = document.createElement("a");
        // link.setAttribute("href", href);
        // link.setAttribute("download", filename);
        // document.body.appendChild(link); // Required for FF
        // link.click(); // This will download the data file named "my_data.csv".
        // document.body.removeChild(link);
        // var textEncoder = new TextEncoder('windows-1252', {NONSTANDARD_allowLegacyEncoding: true});
        // //var BOM = "\uFEFF";
        // var csvData = text;
        // var csvDataEncoded = textEncoder.encode([csvData]);
        // var file = new Blob([csvDataEncoded],{type: "text/plain;charset=windows-1252;"});
        // saveAs(file, filename);
    };
    Api.prototype.getUser = function () {
        return JSON.parse(localStorage.getItem("currentUser"));
    };
    Api.prototype.getCountryCode = function () {
        console.log("     -------------------------     ", localStorage.getItem("countryCode"));
        return localStorage.getItem("countryCode");
    };
    Api.prototype.downloadSaveFileCSV = function (filename, text) {
        var pom = document.createElement('a');
        pom.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(text));
        pom.setAttribute('download', filename);
        if (document.createEvent) {
            var event = document.createEvent('MouseEvents');
            event.initEvent('click', true, true);
            pom.dispatchEvent(event);
        }
        else {
            pom.click();
        }
        document.body.removeChild(pom);
    };
    // Should add token for URL decision making
    Api.prototype.shouldToAddToken = function (endpoint) {
        var urlsNotToAddToken = [
            "recoverPassword"
        ];
        for (var _i = 0, urlsNotToAddToken_1 = urlsNotToAddToken; _i < urlsNotToAddToken_1.length; _i++) {
            var endP = urlsNotToAddToken_1[_i];
            // String.prototype.indexOf returns the position of the
            // string in the other string. If not found, it will return -1
            if (endpoint.indexOf("recoverPassword") !== -1) {
                return false;
            }
        }
        return true;
        // if(endpoint.indexOf("recoverPassword") !== -1){
        //   return false;
        // }else{
        //   return true;
        // }
    };
    Api = __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __decorate */]([
        Object(__WEBPACK_IMPORTED_MODULE_4__angular_core__["Injectable"])(),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __metadata */]("design:paramtypes", [__WEBPACK_IMPORTED_MODULE_1__angular_http__["b" /* Http */],
            __WEBPACK_IMPORTED_MODULE_3__angular_material__["C" /* MatSnackBar */],
            __WEBPACK_IMPORTED_MODULE_2__angular_router__["f" /* Router */],
            __WEBPACK_IMPORTED_MODULE_6_ng2_toastr__["ToastsManager"],
            __WEBPACK_IMPORTED_MODULE_10_angular2_json2csv__["CsvService"]
            //private vcr:ViewContainerRef
            // ,private layoutService:LayoutService
        ])
    ], Api);
    return Api;
}());

var ApplicationVariables = {};


/***/ }),

/***/ 1301:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SlimScrollDirective; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery_slimscroll_jquery_slimscroll_min_js__ = __webpack_require__(1302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery_slimscroll_jquery_slimscroll_min_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery_slimscroll_jquery_slimscroll_min_js__);



var SlimScrollDirective = /** @class */ (function () {
    function SlimScrollDirective(el) {
        this.el = el;
    }
    SlimScrollDirective.prototype.ngAfterViewInit = function () {
        var $el = $(this.el.nativeElement);
        $el.slimScroll({
            height: this.scrollHeight || '100%'
        });
    };
    __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __decorate */]([
        Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"])(),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __metadata */]("design:type", String)
    ], SlimScrollDirective.prototype, "scrollHeight", void 0);
    SlimScrollDirective = __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __decorate */]([
        Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Directive"])({ selector: '[mySlimScroll]' }),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __metadata */]("design:paramtypes", [__WEBPACK_IMPORTED_MODULE_1__angular_core__["ElementRef"]])
    ], SlimScrollDirective);
    return SlimScrollDirective;
}());


/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(57)))

/***/ }),

/***/ 1303:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FileDropDirective; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_fileapi__ = __webpack_require__(1304);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_fileapi___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_fileapi__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_core__ = __webpack_require__(2);



var FileDropDirective = /** @class */ (function () {
    function FileDropDirective(element) {
        this.fileOver = new __WEBPACK_IMPORTED_MODULE_2__angular_core__["EventEmitter"]();
        this.onFileDrop = new __WEBPACK_IMPORTED_MODULE_2__angular_core__["EventEmitter"]();
        this.element = element;
    }
    FileDropDirective.prototype.onDragOver = function (event) {
        var transfer = this.getDataTransfer(event);
        if (!this.haveFiles(transfer.types)) {
            return;
        }
        transfer.dropEffect = 'copy';
        this.preventAndStop(event);
        this.emitFileOver(true);
    };
    FileDropDirective.prototype.onDragLeave = function (event) {
        if (event.currentTarget === this.element[0]) {
            return;
        }
        this.preventAndStop(event);
        this.emitFileOver(false);
    };
    FileDropDirective.prototype.onDrop = function (event) {
        var transfer = this.getDataTransfer(event);
        if (!transfer) {
            return;
        }
        this.preventAndStop(event);
        this.emitFileOver(false);
        this.readFile(transfer.files[0]);
    };
    FileDropDirective.prototype.readFile = function (file) {
        var _this = this;
        var strategy = this.pickStrategy();
        if (!strategy) {
            this.emitFileDrop(file);
        }
        else {
            // XXX Waiting for angular/zone.js#358
            var method = "readAs" + strategy;
            __WEBPACK_IMPORTED_MODULE_1_fileapi__[method](file, function (event) {
                if (event.type === 'load') {
                    _this.emitFileDrop(event.result);
                }
                else if (event.type === 'error') {
                    throw new Error("Couldn't read file '" + file.name + "'");
                }
            });
        }
    };
    FileDropDirective.prototype.emitFileOver = function (isOver) {
        this.fileOver.emit(isOver);
    };
    FileDropDirective.prototype.emitFileDrop = function (file) {
        this.onFileDrop.emit(file);
    };
    FileDropDirective.prototype.pickStrategy = function () {
        if (!this.options) {
            return;
        }
        if (this.hasStrategy(this.options.readAs)) {
            return this.options.readAs;
        }
    };
    FileDropDirective.prototype.hasStrategy = function (type) {
        return [
            'DataURL',
            'BinaryString',
            'ArrayBuffer',
            'Text',
        ].indexOf(type) !== -1;
    };
    FileDropDirective.prototype.getDataTransfer = function (event) {
        return event.dataTransfer ? event.dataTransfer : event.originalEvent.dataTransfer;
    };
    FileDropDirective.prototype.preventAndStop = function (event) {
        event.preventDefault();
        event.stopPropagation();
    };
    FileDropDirective.prototype.haveFiles = function (types) {
        if (!types) {
            return false;
        }
        if (types.indexOf) {
            return types.indexOf('Files') !== -1;
        }
        if (types.contains) {
            return types.contains('Files');
        }
        return false;
    };
    __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __decorate */]([
        Object(__WEBPACK_IMPORTED_MODULE_2__angular_core__["Output"])(),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __metadata */]("design:type", __WEBPACK_IMPORTED_MODULE_2__angular_core__["EventEmitter"])
    ], FileDropDirective.prototype, "fileOver", void 0);
    __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __decorate */]([
        Object(__WEBPACK_IMPORTED_MODULE_2__angular_core__["Output"])(),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __metadata */]("design:type", __WEBPACK_IMPORTED_MODULE_2__angular_core__["EventEmitter"])
    ], FileDropDirective.prototype, "onFileDrop", void 0);
    __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __decorate */]([
        Object(__WEBPACK_IMPORTED_MODULE_2__angular_core__["Input"])(),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __metadata */]("design:type", Object)
    ], FileDropDirective.prototype, "options", void 0);
    __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __decorate */]([
        Object(__WEBPACK_IMPORTED_MODULE_2__angular_core__["HostListener"])('dragover', [
            '$event',
        ]),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __metadata */]("design:type", Function),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __metadata */]("design:paramtypes", [Object]),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __metadata */]("design:returntype", void 0)
    ], FileDropDirective.prototype, "onDragOver", null);
    __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __decorate */]([
        Object(__WEBPACK_IMPORTED_MODULE_2__angular_core__["HostListener"])('dragleave', [
            '$event',
        ]),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __metadata */]("design:type", Function),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __metadata */]("design:paramtypes", [Object]),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __metadata */]("design:returntype", void 0)
    ], FileDropDirective.prototype, "onDragLeave", null);
    __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __decorate */]([
        Object(__WEBPACK_IMPORTED_MODULE_2__angular_core__["HostListener"])('drop', [
            '$event',
        ]),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __metadata */]("design:type", Function),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __metadata */]("design:paramtypes", [Object]),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __metadata */]("design:returntype", void 0)
    ], FileDropDirective.prototype, "onDrop", null);
    FileDropDirective = __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __decorate */]([
        Object(__WEBPACK_IMPORTED_MODULE_2__angular_core__["Directive"])({ selector: '[fileDrop]' }),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __metadata */]("design:paramtypes", [__WEBPACK_IMPORTED_MODULE_2__angular_core__["ElementRef"]])
    ], FileDropDirective);
    return FileDropDirective;
}());



/***/ }),

/***/ 1305:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AppComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_router__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__layout_layout_service__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__providers_api__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_ng2_toastr__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_ng2_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_ng2_toastr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_angular2_json2csv__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_angular2_json2csv___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_angular2_json2csv__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_ngx_zendesk_webwidget__ = __webpack_require__(284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_styles_material2_theme_scss__ = __webpack_require__(1306);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_styles_material2_theme_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_styles_material2_theme_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_styles_bootstrap_scss__ = __webpack_require__(1307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_styles_bootstrap_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_styles_bootstrap_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_styles_layout_scss__ = __webpack_require__(1308);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_styles_layout_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_styles_layout_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_styles_theme_scss__ = __webpack_require__(1309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_styles_theme_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_styles_theme_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_styles_ui_scss__ = __webpack_require__(1310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_styles_ui_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_styles_ui_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_styles_app_scss__ = __webpack_require__(1311);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_styles_app_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_styles_app_scss__);










// 3rd


// custom




var AppComponent = /** @class */ (function () {
    function AppComponent(router, toastr, vRef, _ngxZendeskWebwidgetService) {
        var _this = this;
        this.router = router;
        this.toastr = toastr;
        this.vRef = vRef;
        this._ngxZendeskWebwidgetService = _ngxZendeskWebwidgetService;
        if (localStorage.getItem(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* APPCONFIG */].prefix + 'isLoggedIn') && localStorage.getItem(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* APPCONFIG */].prefix + 'isLoggedIn') == 'true') {
            _ngxZendeskWebwidgetService.show();
            var user = JSON.parse(localStorage.getItem("currentUser"));
            _ngxZendeskWebwidgetService.identify({
                name: user.firstName + '-' + user.adpCustomerInfo.companyName,
                email: user.email,
                organization: user.adpCustomerInfo.companyName
            });
        }
        router.events.subscribe(function (event) {
            if (event instanceof __WEBPACK_IMPORTED_MODULE_2__angular_router__["e" /* NavigationStart */]) {
                // Show loading indicator
            }
            if (event instanceof __WEBPACK_IMPORTED_MODULE_2__angular_router__["c" /* NavigationEnd */]) {
                // Hide loading indicator
                _ngxZendeskWebwidgetService.setHelpCenterSuggestions({ url: true });
                console.log(_this.router.url);
            }
            if (event instanceof __WEBPACK_IMPORTED_MODULE_2__angular_router__["d" /* NavigationError */]) {
                // Hide loading indicator
                // Present error to user
                console.log(event.error);
            }
        });
        //
        // this.toastr.setRootViewContainerRef(vRef);
    }
    AppComponent.prototype.ngOnInit = function () {
        this.AppConfig = __WEBPACK_IMPORTED_MODULE_3__config__["a" /* APPCONFIG */];
        // Scroll to top on route change
        this.router.events.subscribe(function (evt) {
            if (!(evt instanceof __WEBPACK_IMPORTED_MODULE_2__angular_router__["c" /* NavigationEnd */])) {
                return;
            }
            window.scrollTo(0, 0);
        });
    };
    AppComponent = __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __decorate */]([
        Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Component"])({
            selector: 'app-root',
            template: __webpack_require__(1312),
            providers: [__WEBPACK_IMPORTED_MODULE_4__layout_layout_service__["a" /* LayoutService */], __WEBPACK_IMPORTED_MODULE_5__providers_api__["a" /* Api */], __WEBPACK_IMPORTED_MODULE_7_angular2_json2csv__["CsvService"]],
        }),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __metadata */]("design:paramtypes", [__WEBPACK_IMPORTED_MODULE_2__angular_router__["f" /* Router */],
            __WEBPACK_IMPORTED_MODULE_6_ng2_toastr__["ToastsManager"],
            __WEBPACK_IMPORTED_MODULE_1__angular_core__["ViewContainerRef"],
            __WEBPACK_IMPORTED_MODULE_8_ngx_zendesk_webwidget__["c" /* ngxZendeskWebwidgetService */]])
    ], AppComponent);
    return AppComponent;
}());



/***/ }),

/***/ 1306:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1307:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1308:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1309:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1310:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1311:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1312:
/***/ (function(module, exports) {

module.exports = "\r\n<div myPreloader class=\"preloaderbar hide\"><span class=\"bar\"></span></div>\r\n<div id=\"app-main\" class=\"app-main full-height\"\r\n   [ngClass]=\"{'fixed-header' : AppConfig.fixedHeader,\r\n               'nav-collapsed' : AppConfig.navCollapsed,\r\n               'nav-behind' : AppConfig.navBehind,\r\n               'layout-boxed' : AppConfig.layoutBoxed,\r\n               'theme-gray' : AppConfig.theme == 'gray',\r\n               'theme-dark' : AppConfig.theme == 'dark',\r\n               'sidebar-sm' : AppConfig.sidebarWidth == 'small',\r\n               'sidebar-lg' : AppConfig.sidebarWidth == 'large'}\">\r\n  <router-outlet></router-outlet>\r\n</div>"

/***/ }),

/***/ 1313:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PreloaderDirective; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_router__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__layout_service__ = __webpack_require__(110);




var PreloaderDirective = /** @class */ (function () {
    function PreloaderDirective(el, router, layoutService) {
        var _this = this;
        this.el = el;
        this.router = router;
        this.layoutService = layoutService;
        router.events.subscribe(function (event) {
            _this.navigationInterceptor(event);
        });
        this.subscription = layoutService.preloaderState$.subscribe(function (state) {
            _this.updatePreloader(state);
        });
    }
    PreloaderDirective.prototype.ngAfterViewInit = function () {
        this.$el = $(this.el.nativeElement);
    };
    PreloaderDirective.prototype.active = function () {
        if (this.$el) {
            this.$el.removeClass('hide').addClass('active');
        }
    };
    PreloaderDirective.prototype.hide = function () {
        if (this.$el) {
            this.$el.addClass('hide').removeClass('active');
        }
    };
    // Shows and hides the loading spinner during RouterEvent changes
    PreloaderDirective.prototype.navigationInterceptor = function (event) {
        if (event instanceof __WEBPACK_IMPORTED_MODULE_2__angular_router__["e" /* NavigationStart */]) {
            this.active();
        }
        if (event instanceof __WEBPACK_IMPORTED_MODULE_2__angular_router__["c" /* NavigationEnd */]) {
            this.hide();
        }
        // Set loading state to false in both of the below events to hide the spinner in case a request fails
        if (event instanceof __WEBPACK_IMPORTED_MODULE_2__angular_router__["b" /* NavigationCancel */]) {
            this.hide();
        }
        if (event instanceof __WEBPACK_IMPORTED_MODULE_2__angular_router__["d" /* NavigationError */]) {
            this.hide();
        }
    };
    //
    PreloaderDirective.prototype.updatePreloader = function (state) {
        // console.log('change state')
        if (state === 'active') {
            this.active();
        }
        if (state === 'hide') {
            this.hide();
        }
    };
    PreloaderDirective.prototype.ngOnDestroy = function () {
        // prevent memory leak when component destroyed
        this.subscription.unsubscribe();
    };
    PreloaderDirective = __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __decorate */]([
        Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Directive"])({
            selector: '[myPreloader]',
        }),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __metadata */]("design:paramtypes", [__WEBPACK_IMPORTED_MODULE_1__angular_core__["ElementRef"], __WEBPACK_IMPORTED_MODULE_2__angular_router__["f" /* Router */], __WEBPACK_IMPORTED_MODULE_3__layout_service__["a" /* LayoutService */]])
    ], PreloaderDirective);
    return PreloaderDirective;
}());


/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(57)))

/***/ }),

/***/ 1314:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AppHeaderComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(58);



var AppHeaderComponent = /** @class */ (function () {
    function AppHeaderComponent() {
    }
    AppHeaderComponent.prototype.ngOnInit = function () {
        this.AppConfig = __WEBPACK_IMPORTED_MODULE_2__config__["a" /* APPCONFIG */];
    };
    AppHeaderComponent = __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __decorate */]([
        Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Component"])({
            selector: 'my-app-header',
            styles: [],
            template: __webpack_require__(1315)
        })
    ], AppHeaderComponent);
    return AppHeaderComponent;
}());



/***/ }),

/***/ 1315:
/***/ (function(module, exports) {

module.exports = "<section class=\"app-header\">\r\n  <div class=\"app-header-inner\"\r\n     [ngClass]=\"{'bg-color-light': ['11','12','13','14','15','16','21'].indexOf(AppConfig.colorOption) >= 0,\r\n                 'bg-color-dark': AppConfig.colorOption === '31',\r\n                 'bg-color-primary': ['22','32'].indexOf(AppConfig.colorOption) >= 0,\r\n                 'bg-color-success': ['23','33'].indexOf(AppConfig.colorOption) >= 0,\r\n                 'bg-color-info': ['24','34'].indexOf(AppConfig.colorOption) >= 0,\r\n                 'bg-color-warning': ['25','35'].indexOf(AppConfig.colorOption) >= 0,\r\n                 'bg-color-danger': ['26','36'].indexOf(AppConfig.colorOption) >= 0}\">\r\n\r\n    <div class=\"d-lg-none d-xl-none float-left\">\r\n      <button mat-button myToggleOffcanvasNav class=\"md-button header-icon toggle-sidebar-btn\">\r\n        <i class=\"material-icons\">menu</i>\r\n      </button>\r\n    </div>\r\n\r\n\r\n    <div class=\"brand d-none d-lg-inline-block d-xl-inline-block\">\r\n      <h2><a [routerLink]=\"['/']\">{{AppConfig.brand}}</a></h2>\r\n    </div>\r\n\r\n    <div class=\"top-nav-left d-none d-lg-inline-block d-xl-inline-block\">\r\n      <ul class=\"list-unstyled list-inline\">\r\n        <li class=\"list-inline-item\"><button mat-button class=\"md-button header-btn\" myOpenSearchOverlay><i class=\"material-icons\">search</i></button></li>\r\n       <!--  <li class=\"list-inline-item\">\r\n          <button mat-button class=\"md-button header-btn\" [matMenuTriggerFor]=\"appNotification\">\r\n            <i class=\"material-icons\">notifications_none</i>\r\n            <span class=\"badge\">3</span>\r\n          </button>\r\n          <mat-menu #appNotification=\"matMenu\" x-position=\"after\" y-position=\"below\" overlapTrigger=\"false\">\r\n            <mat-list dense>\r\n              <mat-list-item>\r\n                <mat-icon mat-list-avatar>mail_outline</mat-icon>\r\n                <h4 mat-line>New mail from David</h4>\r\n                <p mat-line class=\"text-muted\">5 minutes ago</p>\r\n              </mat-list-item>\r\n              <mat-list-item>\r\n                <mat-icon mat-list-avatar>chat_bubble_outline</mat-icon>\r\n                <h4 mat-line>Message from Jane</h4>\r\n                <p mat-line class=\"text-muted\">15 minutes ago</p>\r\n              </mat-list-item>\r\n              <mat-list-item>\r\n                <mat-icon mat-list-avatar>person_outline</mat-icon>\r\n                <h4 mat-line>New member John joined</h4>\r\n                <p mat-line class=\"text-muted\">1 hour ago</p>\r\n              </mat-list-item>\r\n            </mat-list>\r\n          </mat-menu>\r\n        </li> -->\r\n      </ul>\r\n    </div>\r\n\r\n    <div class=\"top-nav-right\">\r\n      <ul class=\"list-unstyled float-right\">\r\n        <!-- <li>\r\n          <button mat-button class=\"md-button header-btn\" [routerLink]=\"['/app/page/about']\">\r\n            <img src=\"assets/images/g1.jpg\" alt=\"\" class=\"rounded img30_30\">\r\n          </button>\r\n        </li> -->\r\n        <li><button mat-button class=\"md-button header-btn d-lg-none d-xl-none\" myOpenSearchOverlay><i class=\"material-icons\">search</i></button></li>\r\n        <!-- <li><button mat-button class=\"md-button header-btn\"><i class=\"material-icons\">more_vert</i></button></li> -->\r\n      </ul>\r\n    </div>\r\n\r\n  </div>\r\n</section>\r\n"

/***/ }),

/***/ 1316:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AppSidenavComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__angular_router__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__providers_api__ = __webpack_require__(121);





var AppSidenavComponent = /** @class */ (function () {
    function AppSidenavComponent(router, api) {
        this.router = router;
        this.api = api;
        this.userName = "Anonymous";
        this.logoImgUrl = "assets/images/placeholder.jpg";
        this.squareLogoImage = "";
        if (localStorage.getItem(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* APPCONFIG */].prefix + 'isLoggedIn') && localStorage.getItem(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* APPCONFIG */].prefix + 'isLoggedIn') == 'true') {
            this.userName = this.getUserName();
            this.logoImgUrl = this.getImageUrl();
        }
    }
    AppSidenavComponent.prototype.ngOnInit = function () {
        this.AppConfig = __WEBPACK_IMPORTED_MODULE_2__config__["a" /* APPCONFIG */];
        this.squareLogoImage = this.getSquareLogoImage();
    };
    AppSidenavComponent.prototype.toggleCollapsedNav = function () {
        this.AppConfig.navCollapsed = !this.AppConfig.navCollapsed;
    };
    AppSidenavComponent.prototype.logout = function () {
        var _this = this;
        // this.api.activateLoader();
        this.api.get("user/logout").subscribe(function (res) {
            localStorage.removeItem('currentUser');
            localStorage.removeItem(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* APPCONFIG */].prefix + 'isLoggedIn');
            _this.router.navigate(['/extra/login']);
            // this.api.hideLoader();
        }, function (err) {
            console.log(err);
            //if (err.status == 401) {
            localStorage.removeItem('currentUser');
            localStorage.removeItem(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* APPCONFIG */].prefix + 'isLoggedIn');
            _this.router.navigate(['/extra/login']);
            // this.api.hideLoader();
            // }
        });
    };
    AppSidenavComponent.prototype.getUserName = function () {
        var fName = JSON.parse(localStorage.getItem('currentUser')).firstName;
        var lName = JSON.parse(localStorage.getItem('currentUser')).lastName;
        if (typeof fName === 'undefined') {
            fName = " ";
        }
        if (typeof lName === 'undefined') {
            lName = " ";
        }
        return fName + " " + lName;
    };
    AppSidenavComponent.prototype.getImageUrl = function () {
        return JSON.parse(localStorage.getItem('currentUser')).adpCustomerInfo.logoImgUrl || "assets/images/placeholder.jpg";
    };
    AppSidenavComponent.prototype.getSquareLogoImage = function () {
        return this.AppConfig.imagesBaseUrl + "/" + this.api.getADPCustomerUUID() + "/" + this.AppConfig.brandingFolder + "/logoSquare.png?v=" + Math.round((new Date()).getTime() / 1000);
    };
    AppSidenavComponent = __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __decorate */]([
        Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Component"])({
            selector: 'my-app-sidenav',
            styles: [],
            template: __webpack_require__(1317)
        }),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __metadata */]("design:paramtypes", [__WEBPACK_IMPORTED_MODULE_3__angular_router__["f" /* Router */], __WEBPACK_IMPORTED_MODULE_4__providers_api__["a" /* Api */]])
    ], AppSidenavComponent);
    return AppSidenavComponent;
}());



/***/ }),

/***/ 1317:
/***/ (function(module, exports) {

module.exports = "<nav class=\"app-sidebar\" myAutoCloseMobileNav\r\n     [ngClass]=\"{'bg-color-light': ['31','32','33','34','35','36'].indexOf(AppConfig.colorOption) >= 0,\r\n               'bg-color-dark': ['31','32','33','34','35','36'].indexOf(AppConfig.colorOption) < 0 }\">\r\n\r\n  <section class=\"sidebar-header\"\r\n           [ngClass]=\"{'bg-color-dark': ['11','31'].indexOf(AppConfig.colorOption) >= 0,\r\n                   'bg-color-light': AppConfig.colorOption === '21',\r\n                   'bg-color-primary': ['12','22','32'].indexOf(AppConfig.colorOption) >= 0,\r\n                   'bg-color-success': ['13','23','33'].indexOf(AppConfig.colorOption) >= 0,\r\n                   'bg-color-info': ['14','24','34'].indexOf(AppConfig.colorOption) >= 0,\r\n                   'bg-color-warning': ['15','25','35'].indexOf(AppConfig.colorOption) >= 0,\r\n                   'bg-color-danger': ['16','26','36'].indexOf(AppConfig.colorOption) >= 0}\">\r\n    <!-- <span class=\"logo-icon material-icons\">view_compact</span> -->\r\n    <!-- <svg class=\"logo-img\" version=\"1.1\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewBox=\"0 0 250 250\" style=\"enable-background:new 0 0 250 250;\" xml:space=\"preserve\">\r\n      <g>\r\n        <g>\r\n          <polygon class=\"st0\" points=\"125,153.4 100.3,153.4 88.6,182.6 88.6,182.6 66.9,182.6 66.8,182.6 125,52.1 125,52.2 125,52.2 \r\n            125,30 125,30 31.9,63.2 46.1,186.3 125,230 125,230 125,153.4    \"/>\r\n          <polygon class=\"st0\" points=\"108,135.4 125,135.4 125,135.4 125,94.5     \"/>\r\n        </g>\r\n        <g class=\"st1\">\r\n          <polygon class=\"st0\" points=\"125,153.4 149.7,153.4 161.4,182.6 161.4,182.6 183.1,182.6 183.2,182.6 125,52.1 125,52.2 125,52.2 \r\n            125,30 125,30 218.1,63.2 203.9,186.3 125,230 125,230 125,153.4    \"/>\r\n          <polygon class=\"st0\" points=\"142,135.4 125,135.4 125,135.4 125,94.5     \"/>\r\n        </g>\r\n      </g>\r\n    </svg> -->\r\n    <img style=\"    width: 30px; margin: 0px 9px 0 0; margin-top: -5px;\" src=\"../../assets/images/color-small.png\">\r\n    <a [routerLink]=\"['/app/dashboard']\" class=\"brand\">{{AppConfig.brand}}</a>\r\n    <a href=\"javascript:;\" class=\"collapsednav-toggler\" (click)=\"toggleCollapsedNav()\">\r\n      <i class=\"material-icons\" *ngIf=\"this.AppConfig.navCollapsed\">radio_button_unchecked</i>\r\n      <i class=\"material-icons\" *ngIf=\"!this.AppConfig.navCollapsed\">radio_button_checked</i>\r\n    </a>\r\n  </section>\r\n\r\n  <section class=\"sidebar-content\">\r\n    <my-app-sidenav-menu></my-app-sidenav-menu>\r\n  </section>\r\n\r\n  <section class=\"sidebar-footer gv-sidebar-footer\">\r\n    <ul class=\"nav\">\r\n      <li  *ngIf=\"api.isloggedInUserAdmin() && api.getADPCustomerType().toLowerCase() != 'buyer'\"><a mat-button [routerLink]=\"['/app/branding/home']\"><i class=\"nav-icon material-icons\">grade</i><span class=\"nav-text\">Branding</span></a></li>\r\n      <li>\r\n        <a mat-button aria-label=\"menu\" target=\"_blank\" [matMenuTriggerFor]=\"appNotification\">\r\n          <img mat-list-avatar src=\"{{squareLogoImage}}\" alt=\"\" class=\"rounded img30_30\"><span class=\"nav-text\" style=\"margin-left: 15px;\">{{userName}}</span>\r\n        </a>\r\n        <mat-menu #appNotification=\"matMenu\" x-position=\"after\" y-position=\"below\" overlapTrigger=\"false\">\r\n          <mat-list dense class=\"logout-popup\"  style=\"cursor: pointer;\">\r\n            <mat-list-item (click)=\"logout()\" style=\" margin-top: -6px; padding-top: 0;\">\r\n              <mat-icon mat-list-avatar>exit_to_app</mat-icon>\r\n              <h4 mat-line>Logout</h4>\r\n              <!-- <p mat-line class=\"text-muted\">5 minutes ago</p> -->\r\n            </mat-list-item>\r\n            <!-- <mat-list-item>\r\n              <mat-icon mat-list-avatar>chat_bubble_outline</mat-icon>\r\n              <h4 mat-line>Message from Jane</h4>\r\n              <p mat-line class=\"text-muted\">15 minutes ago</p>\r\n            </mat-list-item>\r\n            <mat-list-item>\r\n              <mat-icon mat-list-avatar>person_outline</mat-icon>\r\n              <h4 mat-line>New member John joined</h4>\r\n              <p mat-line class=\"text-muted\">1 hour ago</p>\r\n            </mat-list-item> -->\r\n          </mat-list>\r\n        </mat-menu>\r\n        <!-- <button mat-button class=\"md-button header-btn\" [routerLink]=\"['/app/page/about']\">\r\n          <img src=\"assets/images/g1.jpg\" alt=\"\" class=\"rounded img30_30\"> \r\n        </button>\r\n        <button mat-button class=\"md-button header-btn\" [matMenuTriggerFor]=\"appNotification\">\r\n            <i class=\"material-icons\">notifications_none</i>\r\n            <span class=\"badge\">3</span>\r\n          </button> -->\r\n      </li>\r\n      <!-- <li class=\"list-inline-item\">\r\n          <button mat-button class=\"md-button header-btn\" [matMenuTriggerFor]=\"appNotification\">\r\n            <img src=\"assets/images/g1.jpg\" alt=\"\" class=\"rounded img30_30\"> \r\n            <span class=\"badge\">3</span>\r\n          </button>\r\n          <div mat-button style=\"margin: 5px 10px;\" [matMenuTriggerFor]=\"appNotification\">User Name</div>\r\n          <mat-menu #appNotification=\"matMenu\" x-position=\"after\" y-position=\"below\" overlapTrigger=\"false\">\r\n            <mat-list dense>\r\n              <mat-list-item>\r\n                <mat-icon mat-list-avatar>mail_outline</mat-icon>\r\n                <h4 mat-line>New mail from David</h4>\r\n                <p mat-line class=\"text-muted\">5 minutes ago</p>\r\n              </mat-list-item>\r\n              <mat-list-item>\r\n                <mat-icon mat-list-avatar>chat_bubble_outline</mat-icon>\r\n                <h4 mat-line>Message from Jane</h4>\r\n                <p mat-line class=\"text-muted\">15 minutes ago</p>\r\n              </mat-list-item>\r\n              <mat-list-item>\r\n                <mat-icon mat-list-avatar>person_outline</mat-icon>\r\n                <h4 mat-line>New member John joined</h4>\r\n                <p mat-line class=\"text-muted\">1 hour ago</p>\r\n              </mat-list-item>\r\n            </mat-list>\r\n          </mat-menu>\r\n        </li> -->\r\n    </ul>\r\n  </section>\r\n</nav>\r\n"

/***/ }),

/***/ 1318:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ToggleOffcanvasNavDirective; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__(2);


// off-canvas sidebar for mobile, and this is the trigger
var ToggleOffcanvasNavDirective = /** @class */ (function () {
    function ToggleOffcanvasNavDirective(el) {
        this.el = el;
    }
    ToggleOffcanvasNavDirective.prototype.ngAfterViewInit = function () {
        var $navToggler = $(this.el.nativeElement);
        var $body = $('#body');
        $navToggler.on('click', function (e) {
            // _sidebar.scss, _page-container.scss
            $body.toggleClass('sidebar-mobile-open');
            e.preventDefault();
        });
    };
    ToggleOffcanvasNavDirective = __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __decorate */]([
        Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Directive"])({ selector: '[myToggleOffcanvasNav]' }),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __metadata */]("design:paramtypes", [__WEBPACK_IMPORTED_MODULE_1__angular_core__["ElementRef"]])
    ], ToggleOffcanvasNavDirective);
    return ToggleOffcanvasNavDirective;
}());


/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(57)))

/***/ }),

/***/ 1319:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AutoCloseMobileNavDirective; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_router__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config__ = __webpack_require__(58);




// Mobile only: automatically close sidebar on route change.
var AutoCloseMobileNavDirective = /** @class */ (function () {
    function AutoCloseMobileNavDirective(el, router) {
        this.el = el;
        this.router = router;
    }
    AutoCloseMobileNavDirective.prototype.ngOnInit = function () {
        var $body = $('#body');
        if (__WEBPACK_IMPORTED_MODULE_3__config__["a" /* APPCONFIG */].AutoCloseMobileNav) {
            this.router.events.subscribe(function (event) {
                if (event instanceof __WEBPACK_IMPORTED_MODULE_2__angular_router__["c" /* NavigationEnd */]) {
                    setTimeout(function () {
                        // console.log('NavigationEnd:', event);
                        $body.removeClass('sidebar-mobile-open');
                    }, 0);
                }
            });
        }
    };
    AutoCloseMobileNavDirective = __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __decorate */]([
        Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Directive"])({ selector: '[myAutoCloseMobileNav]' }),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __metadata */]("design:paramtypes", [__WEBPACK_IMPORTED_MODULE_1__angular_core__["ElementRef"], __WEBPACK_IMPORTED_MODULE_2__angular_router__["f" /* Router */]])
    ], AutoCloseMobileNavDirective);
    return AutoCloseMobileNavDirective;
}());


/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(57)))

/***/ }),

/***/ 1320:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AppSidenavMenuComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_router__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__providers_api__ = __webpack_require__(121);





var AppSidenavMenuComponent = /** @class */ (function () {
    function AppSidenavMenuComponent(router, api) {
        this.router = router;
        this.api = api;
        this.listGroups = [
            {
                name: "Tax Group",
                alias: "taxGroup",
                icon: "format_list_bulleted"
            },
            {
                name: "Customer Group",
                alias: "customerGroup",
                icon: "format_list_bulleted"
            },
            {
                name: "Terms Code",
                alias: "termsCode",
                icon: "format_list_bulleted"
            },
            {
                name: "Shipping Services",
                alias: "shippingServices",
                icon: "format_list_bulleted"
            },
            {
                name: "Country",
                alias: "country",
                icon: "format_list_bulleted"
            }
        ];
        localStorage.setItem("allowedTables", JSON.stringify(this.listGroups));
    }
    AppSidenavMenuComponent.prototype.logout = function () {
        localStorage.removeItem(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* APPCONFIG */].prefix + 'isLoggedIn');
        this.router.navigate(['/extra/login']);
    };
    AppSidenavMenuComponent = __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __decorate */]([
        Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Component"])({
            selector: 'my-app-sidenav-menu',
            styles: [],
            template: __webpack_require__(1321)
        }),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __metadata */]("design:paramtypes", [__WEBPACK_IMPORTED_MODULE_2__angular_router__["f" /* Router */], __WEBPACK_IMPORTED_MODULE_4__providers_api__["a" /* Api */]])
    ], AppSidenavMenuComponent);
    return AppSidenavMenuComponent;
}());



/***/ }),

/***/ 1321:
/***/ (function(module, exports) {

module.exports = "<ul class=\"nav\" myAccordionNav myAppendSubmenuIcon mySlimScroll myHighlightActiveItems>\r\n    <!-- <li class=\"nav-header\"><span>Navigation</span></li> -->\r\n    <!-- <li><a mat-button [routerLink]=\"['/app/login']\"><i class=\"nav-icon material-icons\">Login</i><span class=\"nav-text\">Login</span></a></li> -->\r\n    <!--<li class=\"nav-divider\"></li>-->\r\n    <li *ngIf=\"api.isloggedInUserAdmin() && api.getADPCustomerType().toLowerCase() != 'buyer'\"><a mat-button [routerLink]=\"['/app/dashboard']\"><i class=\"nav-icon material-icons\">home</i><span class=\"nav-text\">Dashboard</span></a></li>\r\n    <li class=\"nav-divider\"></li>\r\n\r\n    <li *ngIf=\"api.isloggedInUserAdmin() && api.getADPCustomerType().toLowerCase() != 'buyer'\">\r\n        <a mat-button href=\"#/app/page\"><i class=\"nav-icon material-icons\">insert_chart</i><span class=\"nav-text\">Reports</span></a>\r\n        <ul>\r\n\r\n            <li><a mat-button [routerLink]=\"['/app/reports/onsale']\" ><i class=\"nav-icon material-icons\">attach_money</i><span class=\"nav-text\">Closed Sales</span></a>\r\n                <!-- <ul>\r\n                    <li ><a mat-button [routerLink]=\"['/app/reports/onsale']\"><i class=\"nav-icon material-icons\">shopping_cart</i><span class=\"nav-text\">By SalesRep</span></a></li> -->\r\n                <!-- <li ><a mat-button [routerLink]=\"['/app/reports/onhold']\"><i class=\"nav-icon material-icons\">shopping_cart</i><span class=\"nav-text\">By SalesRep</span></a></li> -->\r\n                <!-- </ul> -->\r\n            </li>\r\n\r\n            <li><a mat-button  [routerLink]=\"['/app/reports/onhold']\"><i class=\"nav-icon material-icons\">trending_up</i><span class=\"nav-text\">Potential Sales</span></a>\r\n                <!-- <ul>\r\n                   <li ><a mat-button [routerLink]=\"['/app/reports/onsale']\"><i class=\"nav-icon material-icons\">shopping_cart</i><span class=\"nav-text\">By Placed Orders</span></a></li> -->\r\n                <!-- <li ><a mat-button [routerLink]=\"['/app/reports/onhold']\"><i class=\"nav-icon material-icons\">shopping_cart</i><span class=\"nav-text\">By SalesRep</span></a></li>\r\n            </ul> -->\r\n            </li>\r\n\r\n\r\n            <!-- bookmark_border -->\r\n            <li><a mat-button [routerLink]=\"['/app/reports/bookmarks']\"><i class=\"nav-icon material-icons\">trending_up</i><span class=\"nav-text\">Trending Products</span></a></li>\r\n            <!-- <li><a mat-button [routerLink]=\"['/app/users/intelliCom']\"><i class=\"nav-icon material-icons\">person</i><span class=\"nav-text\">IntelliRep Users</span></a></li> -->\r\n        </ul>\r\n    </li>\r\n    <!--Inventory Management Starts here-->\r\n    <li>\r\n        <a mat-button href=\"#/app/page\"><i class=\" nav-icon material-icons\">domain</i><span class=\"nav-text\">Inventory Management</span></a>\r\n        <ul>\r\n            <li *ngIf=\"api.isloggedInUserAdmin()\"><a mat-button [routerLink]=\"['/app/inventory/home']\"><i class=\" nav-icon material-icons\">storage</i><span class=\"nav-text\">Products Inventory</span></a></li>\r\n            <li><a mat-button [routerLink]=\"['/app/inventory/reports']\"><i class=\" nav-icon material-icons\">receipt</i><span class=\"nav-text\">Inventory Reports</span></a></li>\r\n            <li><a mat-button [routerLink]=\"['/app/inventory/shipmentNotices']\"><i class=\" nav-icon material-icons\">receipt</i><span class=\"nav-text\">Shipment Notices</span></a></li>\r\n\r\n            <!--<li><a mat-button [routerLink]=\"['/app/inventory/locations']\"><i class=\" nav-icon material-icons\">receipt</i><span class=\"nav-text\">Inventory Locations</span></a></li>-->\r\n\r\n        </ul>\r\n    </li>\r\n\r\n    <li *ngIf=\"api.isloggedInUserAdmin()\">\r\n        <a mat-button href=\"#/app/page\"><i class=\"nav-icon material-icons\">content_copy</i><span class=\"nav-text\">Data Management</span></a>\r\n        <ul>\r\n            <li *ngIf=\"api.isloggedInUserAdmin() && api.getADPCustomerType().toLowerCase() != 'buyer'\"><a mat-button [routerLink]=\"['/app/customers/home']\"><i class=\"nav-icon material-icons\">supervisor_account</i><span class=\"nav-text\">Customers</span></a></li>\r\n            <li><a mat-button [routerLink]=\"['/app/products/home']\"><i class=\"nav-icon material-icons\">storage</i><span class=\"nav-text\">Products</span></a></li>\r\n            <li *ngIf=\"api.isloggedInUserAdmin() && api.getADPCustomerType().toLowerCase() != 'buyer'\"><a mat-button [routerLink]=\"['/app/categories/home']\"><i class=\"nav-icon material-icons\">view_week</i><span class=\"nav-text\">Categories</span></a></li>\r\n            <li *ngIf=\"api.isloggedInUserAdmin() && api.getADPCustomerType().toLowerCase() != 'buyer'\"><a mat-button [routerLink]=\"['/app/attributes/home']\"><i class=\"nav-icon material-icons\">view_week</i><span class=\"nav-text\">Attributes</span></a></li>\r\n            <li *ngIf=\"api.isloggedInUserAdmin() && api.getADPCustomerType().toLowerCase() != 'buyer'\"><a mat-button href=\"#/app/menu\"><i class=\"nav-icon material-icons\">list</i><span class=\"nav-text\">Lookups</span></a>\r\n                <ul>\r\n                    <li *ngFor=\"let list of listGroups\"><a mat-button routerLink=\"/app/lookups/{{list.alias}}\"><i class=\"nav-icon material-icons\">{{list.icon}}</i><span class=\"nav-text\">{{list.name}}</span></a></li>\r\n                </ul>\r\n            </li>\r\n        </ul>\r\n    </li>\r\n\r\n\r\n    <li *ngIf=\"api.isloggedInUserAdmin()\">\r\n        <a mat-button href=\"#/app/page\" ><i class=\"nav-icon material-icons\">people_outline</i><span class=\"nav-text\">Users Management</span></a>\r\n        <ul>\r\n            <li><a mat-button [routerLink]=\"['/app/users/admin']\"><i class=\"nav-icon material-icons\">store</i><span class=\"nav-text\">Admin Users</span></a></li>\r\n            <li *ngIf=\"api.isloggedInUserAdmin() && api.getADPCustomerType().toLowerCase() != 'buyer'\"><a mat-button [routerLink]=\"['/app/users/intelliRep']\"><i class=\"nav-icon material-icons\">store</i><span class=\"nav-text\">IntelliRep Users</span></a></li>\r\n            <li ><a mat-button [routerLink]=\"['/app/users/intellistock']\"><i class=\"nav-icon material-icons\">store</i><span class=\"nav-text\">Intellistock Users</span></a></li>\r\n\r\n            <!--<li><a mat-button [routerLink]=\"['/app/users/intelliCom']\"><i class=\"nav-icon material-icons\">supervisor_account</i><span class=\"nav-text\">System Users</span></a></li> -->\r\n            <!--<li><a mat-button [routerLink]=\"['/app/users/intelliCom']\"><i class=\"nav-icon material-icons\">person</i><span class=\"nav-text\">IntelliCom Users</span></a></li>-->\r\n        </ul>\r\n    </li>\r\n\r\n    <li *ngIf=\"api.isloggedInUserAdmin() && api.getADPCustomerType().toLowerCase().toLowerCase() != 'buyer'\"><a mat-button [routerLink]=\"['/app/buy-supply/buyer']\"><i class=\"nav-icon material-icons\">shop_outline</i><span class=\"nav-text\"> Online Buyers</span></a></li>\r\n    <li *ngIf=\"api.isloggedInUserAdmin() && api.getADPCustomerType().toLowerCase().toLowerCase() != 'supplier'\"><a mat-button [routerLink]=\"['/app/buy-supply/supplier']\"><i class=\"nav-icon material-icons\">contacts_outline</i><span class=\"nav-text\">Online Suppliers</span></a></li>\r\n\r\n    <li *ngIf=\"api.isloggedInUserAdmin()\">\r\n        <a mat-button href=\"#/app/page\"><i class=\"nav-icon material-icons\">receipt</i><span class=\"nav-text\">Transactions</span></a>\r\n        <ul>\r\n            <li *ngIf=\"api.isloggedInUserAdmin() && api.getADPCustomerType().toLowerCase() != 'buyer'\"><a mat-button [routerLink]=\"['/app/transactions/saleOrder']\"><i class=\"nav-icon material-icons\">shopping_cart</i><span class=\"nav-text\">Sales</span></a></li>\r\n            <li *ngIf=\"api.isloggedInUserAdmin() && api.getADPCustomerType().toLowerCase() != 'supplier'\"><a mat-button [routerLink]=\"['/app/transactions/purchaseOrder']\"><i class=\"nav-icon material-icons\">shopping_cart</i><span class=\"nav-text\">Purchases</span></a></li>\r\n\r\n        </ul>\r\n    </li>\r\n\r\n\r\n    <li *ngIf=\"api.isloggedInUserAdmin() && api.getADPCustomerType().toLowerCase() != 'buyer'\">\r\n        <a mat-button href=\"#/app/page\"><i class=\"nav-icon material-icons\">settings_input_composite</i><span class=\"nav-text\">Integrations</span></a>\r\n        <ul>\r\n            <li><a mat-button [routerLink]=\"['/app/integrations/erp']\"><i class=\"nav-icon material-icons\">receipt</i><span class=\"nav-text\">ERP</span></a></li>\r\n            <!-- <li><a mat-button [routerLink]=\"['/app/products/home']\"><i class=\"nav-icon material-icons\">list</i><span class=\"nav-text\">Products</span></a></li>\r\n              <li><a mat-button [routerLink]=\"['/app/categories/home']\"><i class=\"nav-icon material-icons\">view_week</i><span class=\"nav-text\">Categories</span></a></li> -->\r\n        </ul>\r\n    </li>\r\n\r\n\r\n    <li *ngIf=\"api.isloggedInUserAdmin()\">\r\n        <a mat-button href=\"#/app/page\"><i class=\"nav-icon material-icons\">settings</i><span class=\"nav-text\">Account Settings</span></a>\r\n        <ul>\r\n            <li><a mat-button [routerLink]=\"['/app/company/home']\"><i class=\"nav-icon material-icons\">business</i><span class=\"nav-text\">Personalize</span></a></li>\r\n            <li><a mat-button [routerLink]=\"['/app/company/supplier-payment']\"><i class=\"nav-icon material-icons\">attach_money</i><span class=\"nav-text\">Payments</span></a></li>\r\n            <!-- <li><a mat-button [routerLink]=\"['/app/users/intelliCom']\"><i class=\"nav-icon material-icons\">person</i><span class=\"nav-text\">IntelliRep Users</span></a></li> -->\r\n        </ul>\r\n    </li>\r\n    <li *ngIf=\"api.isloggedInUserAdmin()\">\r\n        <a mat-button  [routerLink]=\"['/app/billing/home']\"><i class=\"nav-icon material-icons\">attach_money</i><span class=\"nav-text\">Billing</span></a>\r\n        <!--<ul>-->\r\n        <!--<li><a mat-button [routerLink]=\"['/app/company/home']\"><i class=\"nav-icon material-icons\">business</i><span class=\"nav-text\">Company Profile</span></a></li>-->\r\n        <!--<li><a mat-button [routerLink]=\"['/app/users/intelliCom']\"><i class=\"nav-icon material-icons\">person</i><span class=\"nav-text\">IntelliRep Users</span></a></li>-->\r\n        <!--</ul>-->\r\n    </li>\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n    <!-- <li><a mat-button (click)=\"logout()\"><i class=\"nav-icon material-icons\">exit_to_app</i><span class=\"nav-text\">Logout</span></a></li> -->\r\n    <!-- <li>\r\n      <a mat-button href=\"#/app/ui\"><i class=\"nav-icon material-icons\">bubble_chart</i><span class=\"nav-text\">UI Kit</span></a>\r\n      <ul>\r\n        <li><a mat-button class=\"md-button prepend-icon\" [routerLink]=\"['/app/ui/typography']\"><span>Typography</span></a></li>\r\n        <li><a mat-button class=\"md-button prepend-icon\" [routerLink]=\"['/app/ui/buttons']\"><span>Buttons</span></a></li>\r\n        <li><a mat-button class=\"md-button prepend-icon\" [routerLink]=\"['/app/ui/icons']\"><span>Icons</span><span class=\"badge badge-pill badge-info\">2</span></a></li>\r\n        <li><a mat-button class=\"md-button prepend-icon\" [routerLink]=\"['/app/ui/cards']\"><span>Cards</span></a></li>\r\n        <li><a mat-button class=\"md-button prepend-icon\" [routerLink]=\"['/app/ui/icon-boxes']\"><span>Icon Boxes</span></a></li>\r\n        <li><a mat-button class=\"md-button prepend-icon\" [routerLink]=\"['/app/ui/components']\"><span>Components</span><span class=\"badge badge-pill badge-danger\">12</span></a></li>\r\n        <li><a mat-button class=\"md-button prepend-icon\" [routerLink]=\"['/app/ui/hover']\"><span>Hover</span></a></li>\r\n        <li><a mat-button class=\"md-button prepend-icon\" [routerLink]=\"['/app/ui/feature-callouts']\"><span>Feature Callouts</span></a></li>\r\n        <li><a mat-button class=\"md-button prepend-icon\" [routerLink]=\"['/app/ui/lists']\"><span>Lists</span></a></li>\r\n        <li><a mat-button class=\"md-button prepend-icon\" [routerLink]=\"['/app/ui/sashes']\"><span>Sashes</span></a></li>\r\n        <li><a mat-button class=\"md-button prepend-icon\" [routerLink]=\"['/app/ui/testimonials']\"><span>Testimonials</span></a></li>\r\n        <li><a mat-button class=\"md-button prepend-icon\" [routerLink]=\"['/app/ui/pricing-tables']\"><span>Pricing Tables</span></a></li>\r\n        <li><a mat-button class=\"md-button prepend-icon\" [routerLink]=\"['/app/ui/call-to-actions']\"><span>Call to Actions</span></a></li>\r\n        <li><a mat-button class=\"md-button prepend-icon\" [routerLink]=\"['/app/ui/timeline']\"><span>Timeline</span></a></li>\r\n        <li><a mat-button class=\"md-button prepend-icon\" [routerLink]=\"['/app/ui/boxes']\"><span>Boxes</span></a></li>\r\n        <li><a mat-button class=\"md-button prepend-icon\" [routerLink]=\"['/app/ui/grids']\"><span>Grids</span></a></li>\r\n        <li><a mat-button class=\"md-button prepend-icon\" [routerLink]=\"['/app/ui/color']\"><span>Color</span></a></li>\r\n      </ul>\r\n    </li> -->\r\n\r\n    <!--\r\n      <li>\r\n        <a mat-button href=\"#/app/form\"><i class=\"nav-icon material-icons\">list</i><span class=\"nav-text\">Products</span></a>\r\n        <ul>\r\n          <li><a mat-button class=\"md-button prepend-icon\" [routerLink]=\"['/app/form/input']\"><span>Input</span></a></li>\r\n          <li><a mat-button class=\"md-button prepend-icon\" [routerLink]=\"['/app/form/checkbox']\"><span>Checkbox</span></a></li>\r\n          <li><a mat-button class=\"md-button prepend-icon\" [routerLink]=\"['/app/form/radio-button']\"><span>Radio Button</span></a></li>\r\n          <li><a mat-button class=\"md-button prepend-icon\" [routerLink]=\"['/app/form/chips']\"><span>Chips</span></a></li>\r\n          <li><a mat-button class=\"md-button prepend-icon\" [routerLink]=\"['/app/form/select']\"><span>Select</span></a></li>\r\n          <li><a mat-button class=\"md-button prepend-icon\" [routerLink]=\"['/app/form/slide-toggle']\"><span>Slide Toggle</span></a></li>\r\n          <li><a mat-button class=\"md-button prepend-icon\" [routerLink]=\"['/app/form/slider']\"><span>Slider</span></a></li>\r\n          <li><a mat-button class=\"md-button prepend-icon\" [routerLink]=\"['/app/form/components']\"><span>Components</span><span class=\"badge badge-pill badge-info\">9</span></a></li>\r\n          <li><a mat-button class=\"md-button prepend-icon\" [routerLink]=\"['/app/form/layouts']\"><span>Form Layouts</span></a></li>\r\n          <li><a mat-button class=\"md-button prepend-icon\" [routerLink]=\"['/app/form/validation']\"><span>Form Validation</span></a></li>\r\n        </ul>\r\n      </li> -->\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n    <!--   <li>\r\n        <a mat-button href=\"#/app/form\"><i class=\"nav-icon material-icons\">view_week</i><span class=\"nav-text\">Categories</span></a>\r\n        <ul>\r\n          <li><a mat-button class=\"md-button prepend-icon\" [routerLink]=\"['/app/form/input']\"><span>Input</span></a></li>\r\n          <li><a mat-button class=\"md-button prepend-icon\" [routerLink]=\"['/app/form/checkbox']\"><span>Checkbox</span></a></li>\r\n          <li><a mat-button class=\"md-button prepend-icon\" [routerLink]=\"['/app/form/radio-button']\"><span>Radio Button</span></a></li>\r\n          <li><a mat-button class=\"md-button prepend-icon\" [routerLink]=\"['/app/form/chips']\"><span>Chips</span></a></li>\r\n          <li><a mat-button class=\"md-button prepend-icon\" [routerLink]=\"['/app/form/select']\"><span>Select</span></a></li>\r\n          <li><a mat-button class=\"md-button prepend-icon\" [routerLink]=\"['/app/form/slide-toggle']\"><span>Slide Toggle</span></a></li>\r\n          <li><a mat-button class=\"md-button prepend-icon\" [routerLink]=\"['/app/form/slider']\"><span>Slider</span></a></li>\r\n          <li><a mat-button class=\"md-button prepend-icon\" [routerLink]=\"['/app/form/components']\"><span>Components</span><span class=\"badge badge-pill badge-info\">9</span></a></li>\r\n          <li><a mat-button class=\"md-button prepend-icon\" [routerLink]=\"['/app/form/layouts']\"><span>Form Layouts</span></a></li>\r\n          <li><a mat-button class=\"md-button prepend-icon\" [routerLink]=\"['/app/form/validation']\"><span>Form Validation</span></a></li>\r\n        </ul>\r\n      </li>\r\n     -->\r\n\r\n\r\n\r\n\r\n\r\n    <!-- <li>\r\n      <a mat-button href=\"#/app/table\"><i class=\"nav-icon material-icons\">list</i><span class=\"nav-text\">Products</span></a>\r\n      <ul>\r\n        <li><a mat-button class=\"md-button prepend-icon\" [routerLink]=\"['/app/table/static']\"><span>Static Tables</span></a></li>\r\n        <li><a mat-button class=\"md-button prepend-icon\" [routerLink]=\"['/app/table/responsive']\"><span>Responsive Tables</span></a></li>\r\n        <li><a mat-button class=\"md-button prepend-icon\" [routerLink]=\"['/app/table/data-table']\"><span>Data Tables</span></a></li>\r\n      </ul>\r\n    </li> -->\r\n    <!--<li>-->\r\n    <!--<a mat-button href=\"#/app/chart\"><i class=\"nav-icon material-icons\">equalizer</i><span class=\"nav-text\">Charts</span></a>-->\r\n    <!--<ul>-->\r\n    <!--<li><a mat-button class=\"md-button prepend-icon\" [routerLink]=\"['/app/chart/line']\">Line &amp; Area</a></li>-->\r\n    <!--<li><a mat-button class=\"md-button prepend-icon\" [routerLink]=\"['/app/chart/bar']\">Bar</a></li>-->\r\n    <!--<li><a mat-button class=\"md-button prepend-icon\" [routerLink]=\"['/app/chart/pie']\">Pie</a></li>-->\r\n    <!--<li><a mat-button class=\"md-button prepend-icon\" [routerLink]=\"['/app/chart/scatter']\">Scatter</a></li>-->\r\n    <!--<li><a mat-button class=\"md-button prepend-icon\" [routerLink]=\"['/app/chart/radar']\">Radar</a></li>-->\r\n    <!--<li><a mat-button class=\"md-button prepend-icon\" [routerLink]=\"['/app/chart/funnel']\">Funnel</a></li>-->\r\n    <!--<li><a mat-button class=\"md-button prepend-icon\" [routerLink]=\"['/app/chart/more']\">More</a></li>-->\r\n    <!--</ul>-->\r\n    <!--</li>-->\r\n    <!--  <li class=\"nav-divider\"></li>\r\n     <li>\r\n       <a mat-button href=\"#/app/page\"><i class=\"nav-icon material-icons\">content_copy</i><span class=\"nav-text\">Pages</span></a>\r\n       <ul>\r\n         <li><a mat-button class=\"md-button prepend-icon\" [routerLink]=\"['/app/page/about']\">About</a></li>\r\n         <li><a mat-button class=\"md-button prepend-icon\" [routerLink]=\"['/app/page/services']\">Services</a></li>\r\n         <li><a mat-button class=\"md-button prepend-icon\" [routerLink]=\"['/app/page/contact']\">Contact</a></li>\r\n         <li><a mat-button class=\"md-button prepend-icon\" [routerLink]=\"['/app/page/careers']\">Careers</a></li>\r\n         <li><a mat-button class=\"md-button prepend-icon\" [routerLink]=\"['/app/page/blog']\">Blog</a></li>\r\n         <li><a mat-button class=\"md-button prepend-icon\" [routerLink]=\"['/app/page/faqs']\">FAQs</a></li>\r\n         <li><a mat-button class=\"md-button prepend-icon\" [routerLink]=\"['/app/page/terms']\">Terms of Service</a></li>\r\n       </ul>\r\n     </li>\r\n\r\n     <li>\r\n       <a mat-button href=\"#/extra\"><i class=\"nav-icon material-icons\">more_horiz</i><span class=\"nav-text\">Extra Pages</span></a>\r\n       <ul>\r\n         <li><a mat-button class=\"md-button prepend-icon\" [routerLink]=\"['/extra/login']\"><span>Login</span></a></li>\r\n         <li><a mat-button class=\"md-button prepend-icon\" [routerLink]=\"['/extra/sign-up']\"><span>Sign Up</span></a></li>\r\n         <li><a mat-button class=\"md-button prepend-icon\" [routerLink]=\"['/extra/forgot-password']\"><span>Forgot Password</span></a></li>\r\n         <li><a mat-button class=\"md-button prepend-icon\" [routerLink]=\"['/extra/confirm-email']\"><span>Confirm Email</span></a></li>\r\n         <li><a mat-button class=\"md-button prepend-icon\" [routerLink]=\"['/extra/lock-screen']\"><span>Lock Screen</span></a></li>\r\n         <li><a mat-button class=\"md-button prepend-icon\" [routerLink]=\"['/extra/404']\"><span>404 Error</span></a></li>\r\n         <li><a mat-button class=\"md-button prepend-icon\" [routerLink]=\"['/extra/500']\"><span>500 Error</span></a></li>\r\n         <li><a mat-button class=\"md-button prepend-icon\" [routerLink]=\"['/extra/maintenance']\"><span>Maintenance</span></a></li>\r\n       </ul>\r\n     </li>\r\n\r\n\r\n\r\n     <li><a mat-button (click)=\"logout()\"><i class=\"nav-icon material-icons\">exit_to_app</i><span class=\"nav-text\">Logout</span></a></li> -->\r\n\r\n    <!--<li>-->\r\n    <!--<a mat-button href=\"#/app/pglayout\"><i class=\"nav-icon material-icons\">view_array</i><span class=\"nav-text\">Page Layouts</span></a>-->\r\n    <!--<ul>-->\r\n    <!--<li><a mat-button class=\"md-button prepend-icon\" [routerLink]=\"['/app/pglayout/full-width']\"><span>Full Width</span></a></li>-->\r\n    <!--<li><a mat-button class=\"md-button prepend-icon\" [routerLink]=\"['/app/pglayout/centered']\"><span>Centered</span></a></li>-->\r\n    <!--<li><a mat-button class=\"md-button prepend-icon\" [routerLink]=\"['/fullscreen']\"><span>Fullscreen</span></a></li>-->\r\n    <!--<li><a mat-button class=\"md-button prepend-icon\" [routerLink]=\"['/app/pglayout/with-tabs']\"><span>With Tabs</span></a></li>-->\r\n    <!--</ul>-->\r\n    <!--</li>-->\r\n    <!--<li>-->\r\n    <!--<a mat-button href=\"#/app/ecommerce\"><i class=\"nav-icon material-icons\">shopping_cart</i><span class=\"nav-text\">eCommerce</span></a>-->\r\n    <!--<ul>-->\r\n    <!--<li><a mat-button class=\"md-button prepend-icon\" [routerLink]=\"['/app/ecommerce/products']\"><span>Products</span></a></li>-->\r\n    <!--<li><a mat-button class=\"md-button prepend-icon\" [routerLink]=\"['/app/ecommerce/horizontal-products']\"><span>Products (Horizontal)</span></a></li>-->\r\n    <!--<li><a mat-button class=\"md-button prepend-icon\" [routerLink]=\"['/app/ecommerce/invoice']\"><span>Invoice</span></a></li>-->\r\n    <!--</ul>-->\r\n    <!--</li>-->\r\n    <!--<li>-->\r\n    <!--<a mat-button href=\"#/app/menu\"><i class=\"nav-icon material-icons\">sort</i><span class=\"nav-text\">Menu Levels</span></a>-->\r\n    <!--<ul>-->\r\n    <!--<li><a mat-button class=\"md-button prepend-icon\" href=\"javascript:;\"><span>Level 1</span></a></li>-->\r\n    <!--<li>-->\r\n    <!--<a mat-button class=\"md-button prepend-icon\" href=\"javascript:;\"><span>Level 1</span></a>-->\r\n    <!--<ul>-->\r\n    <!--<li><a mat-button class=\"md-button\" href=\"javascript:;\"><span>Level 2</span></a></li>-->\r\n    <!--<li>-->\r\n    <!--<a mat-button class=\"md-button\" href=\"javascript:;\"><span>Level 2</span></a>-->\r\n    <!--<ul>-->\r\n    <!--<li><a mat-button class=\"md-button\" href=\"javascript:;\"><span>Level 3</span></a></li>-->\r\n    <!--<li><a mat-button class=\"md-button\" href=\"javascript:;\"><span>Level 3</span></a></li>-->\r\n    <!--</ul>-->\r\n    <!--</li>-->\r\n    <!--</ul>-->\r\n    <!--</li>-->\r\n    <!--</ul>-->\r\n    <!--</li>-->\r\n    <!--<li class=\"nav-divider\"></li>-->\r\n    <!--<li class=\"li-small\"><a mat-button [routerLink]=\"['/app/form/components']\"><i class=\"nav-icon nav-dot material-icons color-info\">fiber_manual_record</i><span class=\"nav-text\">Form Components</span></a></li>-->\r\n    <!--<li class=\"li-small\"><a mat-button [routerLink]=\"['/app/ui/components']\"><i class=\"nav-icon nav-dot material-icons color-success\">fiber_manual_record</i><span class=\"nav-text\">UI Components</span></a></li>-->\r\n    <!--<li class=\"li-small\"><a mat-button href=\"http://iarouse.com/dist-angular-material/landing/\" target=\"_blank\"><i class=\"nav-icon nav-dot material-icons color-danger\">fiber_manual_record</i><span class=\"nav-text\">Material Landing</span></a></li>-->\r\n</ul>\r\n"

/***/ }),

/***/ 1322:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AccordionNavDirective; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__(2);


var AccordionNavDirective = /** @class */ (function () {
    function AccordionNavDirective(el) {
        this.el = el;
    }
    AccordionNavDirective.prototype.ngAfterViewInit = function () {
        // on click, open it's own ul, close sibling li opened ul & sub ul
        // on click, close it's own ul & sub ul
        var $nav = $(this.el.nativeElement);
        var slideTime = 250;
        var $lists = $nav.find('ul').parent('li');
        $lists.append('<i class="material-icons icon-has-ul">arrow_drop_down</i>');
        var $As = $lists.children('a');
        // Disable a link that has ul
        $As.on('click', function (event) {
            event.preventDefault();
        });
        // Accordion nav
        $nav.on('click', function (e) {
            var target = e.target;
            var $parentLi = $(target).closest('li'); // closest, insead of parent, so it still works when click on i icons
            if (!$parentLi.length) {
                return;
            } // return if doesn't click on li
            var $subUl = $parentLi.children('ul');
            // let depth = $subUl.parents().length; // but some li has no sub ul, so...
            var depth = $parentLi.parents().length + 1;
            // filter out all elements (except target) at current depth or greater
            var allAtDepth = $nav.find('ul').filter(function () {
                if ($(this).parents().length >= depth && this !== $subUl.get(0)) {
                    return true;
                }
            });
            allAtDepth.slideUp(slideTime).closest('li').removeClass('open');
            // Toggle target
            if ($parentLi.has('ul').length) {
                $parentLi.toggleClass('open');
            }
            $subUl.stop().slideToggle(slideTime);
        });
    };
    AccordionNavDirective = __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __decorate */]([
        Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Directive"])({ selector: '[myAccordionNav]' }),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __metadata */]("design:paramtypes", [__WEBPACK_IMPORTED_MODULE_1__angular_core__["ElementRef"]])
    ], AccordionNavDirective);
    return AccordionNavDirective;
}());


/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(57)))

/***/ }),

/***/ 1323:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AppendSubmenuIconDirective; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__(2);


var AppendSubmenuIconDirective = /** @class */ (function () {
    function AppendSubmenuIconDirective(el) {
        this.el = el;
    }
    AppendSubmenuIconDirective.prototype.ngAfterViewInit = function () {
        var $el = $(this.el.nativeElement);
        $el.find('.prepend-icon').prepend('<i class="material-icons">keyboard_arrow_right</i>');
    };
    AppendSubmenuIconDirective = __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __decorate */]([
        Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Directive"])({ selector: '[myAppendSubmenuIcon]' }),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __metadata */]("design:paramtypes", [__WEBPACK_IMPORTED_MODULE_1__angular_core__["ElementRef"]])
    ], AppendSubmenuIconDirective);
    return AppendSubmenuIconDirective;
}());


/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(57)))

/***/ }),

/***/ 1324:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HighlightActiveItemsDirective; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_common__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__angular_router__ = __webpack_require__(64);




var HighlightActiveItemsDirective = /** @class */ (function () {
    function HighlightActiveItemsDirective(el, location, router) {
        this.el = el;
        this.location = location;
        this.router = router;
    }
    HighlightActiveItemsDirective.prototype.ngAfterViewInit = function () {
        var $el = $(this.el.nativeElement);
        var $links = $el.find('a');
        function highlightActive(links) {
            var path = location.hash;
            // console.log(path);
            links.each(function (i, link) {
                var $link = $(link);
                var $li = $link.parent('li');
                var href = $link.attr('href');
                // console.log(href);
                if ($li.hasClass('active')) {
                    $li.removeClass('active');
                }
                if (path.indexOf(href) === 0) {
                    $li.addClass('active');
                }
            });
        }
        highlightActive($links);
        this.router.events.subscribe(function (evt) {
            if (!(evt instanceof __WEBPACK_IMPORTED_MODULE_3__angular_router__["c" /* NavigationEnd */])) {
                return;
            }
            highlightActive($links);
        });
    };
    HighlightActiveItemsDirective = __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __decorate */]([
        Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Directive"])({ selector: '[myHighlightActiveItems]' }),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __metadata */]("design:paramtypes", [__WEBPACK_IMPORTED_MODULE_1__angular_core__["ElementRef"], __WEBPACK_IMPORTED_MODULE_2__angular_common__["Location"], __WEBPACK_IMPORTED_MODULE_3__angular_router__["f" /* Router */]])
    ], HighlightActiveItemsDirective);
    return HighlightActiveItemsDirective;
}());


/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(57)))

/***/ }),

/***/ 1325:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AppCustomizerComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__layout_service__ = __webpack_require__(110);




var AppCustomizerComponent = /** @class */ (function () {
    function AppCustomizerComponent(layoutService) {
        var _this = this;
        this.layoutService = layoutService;
        this.onLayoutChange = function () {
            _this.layoutService.updateEChartsState(true);
        };
    }
    AppCustomizerComponent.prototype.ngOnInit = function () {
        this.AppConfig = __WEBPACK_IMPORTED_MODULE_2__config__["a" /* APPCONFIG */];
    };
    AppCustomizerComponent = __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __decorate */]([
        Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Component"])({
            selector: 'my-app-customizer',
            styles: [],
            template: __webpack_require__(1326),
        }),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __metadata */]("design:paramtypes", [__WEBPACK_IMPORTED_MODULE_3__layout_service__["a" /* LayoutService */]])
    ], AppCustomizerComponent);
    return AppCustomizerComponent;
}());



/***/ }),

/***/ 1326:
/***/ (function(module, exports) {

module.exports = "<section class=\"quickview-wrapper customizer d-none d-lg-block d-xl-block\" id=\"quickview-customizer\">\r\n  <a class=\"customizer-close\" href=\"javascript:;\" myToggleQuickview=\"customizer\"><span class=\"material-icons\">close</span></a>\r\n  <a class=\"customizer-toggle\" href=\"javascript:;\" myToggleQuickview=\"customizer\"><span class=\"material-icons\">settings</span></a>\r\n\r\n  <div class=\"quickview-inner\" mySlimScroll>\r\n    <div>\r\n      <p class=\"customizer-header\">Customizer</p>\r\n      <p class=\"small no-margin\">Customize and preview in real time.</p>\r\n\r\n      <div class=\"divider divider-lg divider-solid\"></div>\r\n      <h4 class=\"section-header\">Layout Options</h4>\r\n      <div class=\"divider divider-sm\"></div>\r\n      <mat-list>\r\n        <mat-list-item>\r\n          <p>Fixed Header</p>\r\n          <mat-slide-toggle class=\"mat-secondary\" [(ngModel)]=\"AppConfig.fixedHeader\"></mat-slide-toggle>\r\n        </mat-list-item>\r\n        <mat-list-item>\r\n          <p>Collapsed Sidebar</p>\r\n          <mat-slide-toggle class=\"mat-secondary\" [(ngModel)]=\"AppConfig.navCollapsed\" (change)=\"onLayoutChange()\"></mat-slide-toggle>\r\n        </mat-list-item>\r\n        <mat-list-item>\r\n          <p>Full Width Header</p>\r\n          <mat-slide-toggle class=\"mat-secondary\" [(ngModel)]=\"AppConfig.navBehind\"></mat-slide-toggle>\r\n        </mat-list-item>\r\n        <mat-list-item>\r\n          <p>Boxed Layout</p>\r\n          <mat-slide-toggle class=\"mat-secondary\" [(ngModel)]=\"AppConfig.layoutBoxed\" (change)=\"onLayoutChange()\"></mat-slide-toggle>\r\n        </mat-list-item>\r\n        <mat-list-item>\r\n          <p>Sidebar Width</p>\r\n          <mat-select class=\"no-margin\" style=\"width: 80px;\" [(ngModel)]=\"AppConfig.sidebarWidth\" (change)=\"onLayoutChange()\">\r\n            <mat-option value=\"small\">small</mat-option>\r\n            <mat-option value=\"middle\" >middle</mat-option>\r\n            <mat-option value=\"large\" >large</mat-option>\r\n          </mat-select>\r\n        </mat-list-item>\r\n      </mat-list>\r\n\r\n\r\n      <div class=\"divider divider-lg divider-solid\"></div>\r\n      <h4 class=\"section-header\">Color Options</h4>\r\n      <p class=\"small no-margin\">Tip: Additionally, you can active \"Full Width Header\" above</p>\r\n      <div class=\"divider\"></div>\r\n      <div class=\"row\">\r\n        <div class=\"col-4\">\r\n          <label class=\"color-option-check\">\r\n            <input type=\"radio\" name=\"color\" value=\"11\" [(ngModel)]=\"AppConfig.colorOption\">\r\n            <span class=\"color-option-item bg-color-page\">\r\n              <span class=\"overlay\"><span class=\"material-icons\">check</span></span>\r\n              <span class=\"bg-color-dark item-header\"></span>\r\n              <span class=\"bg-color-light item-header\"></span>\r\n              <span class=\"bg-color-dark\"></span>\r\n            </span>\r\n          </label>\r\n          <label class=\"color-option-check\">\r\n            <input type=\"radio\" name=\"color\" value=\"12\" [(ngModel)]=\"AppConfig.colorOption\">\r\n            <span class=\"color-option-item bg-color-page\">\r\n              <span class=\"overlay\"><span class=\"material-icons\">check</span></span>\r\n              <span class=\"bg-color-primary item-header\"></span>\r\n              <span class=\"bg-color-light item-header\"></span>\r\n              <span class=\"bg-color-dark\"></span> \r\n            </span>\r\n          </label>\r\n          <label class=\"color-option-check\">\r\n            <input type=\"radio\" name=\"color\" value=\"13\" [(ngModel)]=\"AppConfig.colorOption\">\r\n            <span class=\"color-option-item bg-color-page\">\r\n              <span class=\"overlay\"><span class=\"material-icons\">check</span></span>\r\n              <span class=\"bg-color-success item-header\"></span>\r\n              <span class=\"bg-color-light item-header\"></span>\r\n              <span class=\"bg-color-dark\"></span> \r\n            </span>\r\n          </label>\r\n          <label class=\"color-option-check\">\r\n            <input type=\"radio\" name=\"color\" value=\"14\" [(ngModel)]=\"AppConfig.colorOption\">\r\n            <span class=\"color-option-item bg-color-page\">\r\n              <span class=\"overlay\"><span class=\"material-icons\">check</span></span>\r\n              <span class=\"bg-color-info item-header\"></span>\r\n              <span class=\"bg-color-light item-header\"></span>\r\n              <span class=\"bg-color-dark\"></span> \r\n            </span>\r\n          </label>\r\n          <label class=\"color-option-check\">\r\n            <input type=\"radio\" name=\"color\" value=\"15\" [(ngModel)]=\"AppConfig.colorOption\">\r\n            <span class=\"color-option-item bg-color-page\">\r\n              <span class=\"overlay\"><span class=\"material-icons\">check</span></span>\r\n              <span class=\"bg-color-warning item-header\"></span>\r\n              <span class=\"bg-color-light item-header\"></span>\r\n              <span class=\"bg-color-dark\"></span> \r\n            </span>\r\n          </label>\r\n          <label class=\"color-option-check\">\r\n            <input type=\"radio\" name=\"color\" value=\"16\" [(ngModel)]=\"AppConfig.colorOption\">\r\n            <span class=\"color-option-item bg-color-page\">\r\n              <span class=\"overlay\"><span class=\"material-icons\">check</span></span>\r\n              <span class=\"bg-color-danger item-header\"></span>\r\n              <span class=\"bg-color-light item-header\"></span>\r\n              <span class=\"bg-color-dark\"></span> \r\n            </span>\r\n          </label>\r\n        </div>\r\n\r\n        <div class=\"col-4\">\r\n          <label class=\"color-option-check\">\r\n            <input type=\"radio\" name=\"color\" value=\"21\" [(ngModel)]=\"AppConfig.colorOption\">\r\n            <span class=\"color-option-item bg-color-page\">\r\n              <span class=\"overlay\"><span class=\"material-icons\">check</span></span>\r\n              <span class=\"bg-color-light item-header\"></span>\r\n              <span class=\"bg-color-light item-header\"></span>\r\n              <span class=\"bg-color-dark\"></span> \r\n            </span>\r\n          </label>\r\n          <label class=\"color-option-check\">\r\n            <input type=\"radio\" name=\"color\" value=\"22\" [(ngModel)]=\"AppConfig.colorOption\">\r\n            <span class=\"color-option-item bg-color-page\">\r\n              <span class=\"overlay\"><span class=\"material-icons\">check</span></span>\r\n              <span class=\"bg-color-primary item-header\"></span>\r\n              <span class=\"bg-color-primary item-header\"></span>\r\n              <span class=\"bg-color-dark\"></span> \r\n            </span>\r\n          </label>\r\n          <label class=\"color-option-check\">\r\n            <input type=\"radio\" name=\"color\" value=\"23\" [(ngModel)]=\"AppConfig.colorOption\">\r\n            <span class=\"color-option-item bg-color-page\">\r\n              <span class=\"overlay\"><span class=\"material-icons\">check</span></span>\r\n              <span class=\"bg-color-success item-header\"></span>\r\n              <span class=\"bg-color-success item-header\"></span>\r\n              <span class=\"bg-color-dark\"></span> \r\n            </span>\r\n          </label>\r\n          <label class=\"color-option-check\">\r\n            <input type=\"radio\" name=\"color\" value=\"24\" [(ngModel)]=\"AppConfig.colorOption\">\r\n            <span class=\"color-option-item bg-color-page\">\r\n              <span class=\"overlay\"><span class=\"material-icons\">check</span></span>\r\n              <span class=\"bg-color-info item-header\"></span>\r\n              <span class=\"bg-color-info item-header\"></span>\r\n              <span class=\"bg-color-dark\"></span> \r\n            </span>\r\n          </label>\r\n          <label class=\"color-option-check\">\r\n            <input type=\"radio\" name=\"color\" value=\"25\" [(ngModel)]=\"AppConfig.colorOption\">\r\n            <span class=\"color-option-item bg-color-page\">\r\n              <span class=\"overlay\"><span class=\"material-icons\">check</span></span>\r\n              <span class=\"bg-color-warning item-header\"></span>\r\n              <span class=\"bg-color-warning item-header\"></span>\r\n              <span class=\"bg-color-dark\"></span> \r\n            </span>\r\n          </label>\r\n          <label class=\"color-option-check\">\r\n            <input type=\"radio\" name=\"color\" value=\"26\" [(ngModel)]=\"AppConfig.colorOption\">\r\n            <span class=\"color-option-item bg-color-page\">\r\n              <span class=\"overlay\"><span class=\"material-icons\">check</span></span>\r\n              <span class=\"bg-color-danger item-header\"></span>\r\n              <span class=\"bg-color-danger item-header\"></span>\r\n              <span class=\"bg-color-dark\"></span> \r\n            </span>\r\n          </label>                 \r\n        </div>\r\n        <div class=\"col-4\">\r\n          <label class=\"color-option-check\">\r\n            <input type=\"radio\" name=\"color\" value=\"31\" [(ngModel)]=\"AppConfig.colorOption\">\r\n            <span class=\"color-option-item bg-color-page\">\r\n              <span class=\"overlay\"><span class=\"material-icons\">check</span></span>\r\n              <span class=\"bg-color-dark item-header\"></span>\r\n              <span class=\"bg-color-dark item-header\"></span>\r\n              <span class=\"bg-color-light\"></span> \r\n            </span>\r\n          </label> \r\n          <label class=\"color-option-check\">\r\n            <input type=\"radio\" name=\"color\" value=\"32\" [(ngModel)]=\"AppConfig.colorOption\">\r\n            <span class=\"color-option-item bg-color-page\">\r\n              <span class=\"overlay\"><span class=\"material-icons\">check</span></span>\r\n              <span class=\"bg-color-primary item-header\"></span>\r\n              <span class=\"bg-color-primary item-header\"></span>\r\n              <span class=\"bg-color-light\"></span> \r\n            </span>\r\n          </label>\r\n          <label class=\"color-option-check\">\r\n            <input type=\"radio\" name=\"color\" value=\"33\" [(ngModel)]=\"AppConfig.colorOption\">\r\n            <span class=\"color-option-item bg-color-page\">\r\n              <span class=\"overlay\"><span class=\"material-icons\">check</span></span>\r\n              <span class=\"bg-color-success item-header\"></span>\r\n              <span class=\"bg-color-success item-header\"></span>\r\n              <span class=\"bg-color-light\"></span> \r\n            </span>\r\n          </label>\r\n          <label class=\"color-option-check\">\r\n            <input type=\"radio\" name=\"color\" value=\"34\" [(ngModel)]=\"AppConfig.colorOption\">\r\n            <span class=\"color-option-item bg-color-page\">\r\n              <span class=\"overlay\"><span class=\"material-icons\">check</span></span>\r\n              <span class=\"bg-color-info item-header\"></span>\r\n              <span class=\"bg-color-info item-header\"></span>\r\n              <span class=\"bg-color-light\"></span> \r\n            </span>\r\n          </label>\r\n          <label class=\"color-option-check\">\r\n            <input type=\"radio\" name=\"color\" value=\"35\" [(ngModel)]=\"AppConfig.colorOption\">\r\n            <span class=\"color-option-item bg-color-page\">\r\n              <span class=\"overlay\"><span class=\"material-icons\">check</span></span>\r\n              <span class=\"bg-color-warning item-header\"></span>\r\n              <span class=\"bg-color-warning item-header\"></span>\r\n              <span class=\"bg-color-light\"></span> \r\n            </span>\r\n          </label>\r\n          <label class=\"color-option-check\">\r\n            <input type=\"radio\" name=\"color\" value=\"36\" [(ngModel)]=\"AppConfig.colorOption\">\r\n            <span class=\"color-option-item bg-color-page\">\r\n              <span class=\"overlay\"><span class=\"material-icons\">check</span></span>\r\n              <span class=\"bg-color-danger item-header\"></span>\r\n              <span class=\"bg-color-danger item-header\"></span>\r\n              <span class=\"bg-color-light\"></span> \r\n            </span>\r\n          </label>                 \r\n        </div>\r\n      </div>\r\n\r\n\r\n\r\n      <div class=\"divider divider-lg divider-solid\"></div>\r\n      <h4 class=\"section-header\">Theme Options</h4>\r\n      <div class=\"divider\"></div>\r\n\r\n      <div class=\"row no-margin theme-options clearfix\">\r\n        <div class=\"col-4\">\r\n          <label class=\"theme-option-check\">\r\n            <input type=\"radio\" name=\"theme\" value=\"dark\" [(ngModel)]=\"AppConfig.theme\">\r\n            <span class=\"theme-option-item bg-color-dark\">\r\n              <span class=\"overlay\"><span class=\"material-icons\">check</span></span>\r\n              <span>Dark</span>\r\n            </span>\r\n          </label>\r\n        </div>\r\n        <div class=\"col-4\">\r\n          <label class=\"theme-option-check\">\r\n            <input type=\"radio\" name=\"theme\" value=\"gray\" [(ngModel)]=\"AppConfig.theme\">\r\n            <span class=\"theme-option-item bg-color-gray\">\r\n              <span class=\"overlay\"><span class=\"material-icons\">check</span></span>\r\n              <span>Gray</span>\r\n            </span>\r\n          </label>\r\n        </div>\r\n        <div class=\"col-4\">\r\n          <label class=\"theme-option-check\">\r\n            <input type=\"radio\" name=\"theme\" value=\"light\" [(ngModel)]=\"AppConfig.theme\">\r\n            <span class=\"theme-option-item bg-color-page\">\r\n              <span class=\"overlay\"><span class=\"material-icons\">check</span></span>\r\n              <span>Light</span>\r\n            </span>\r\n          </label>\r\n        </div>\r\n      </div>\r\n      <div class=\"divider divider-lg divider-solid\"></div>\r\n      <div class=\"text-right\">\r\n        <a target=\"_blank\" [href]=\"AppConfig.productLink\">Download it Now</a>\r\n      </div>\r\n\r\n    </div>\r\n  </div>\r\n</section>"

/***/ }),

/***/ 1327:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ToggleQuickviewDirective; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__(2);


var ToggleQuickviewDirective = /** @class */ (function () {
    function ToggleQuickviewDirective(el) {
        this.el = el;
    }
    ToggleQuickviewDirective.prototype.ngAfterViewInit = function () {
        var $el = $(this.el.nativeElement);
        var $body = $('#body');
        var target = this.myToggleQuickview;
        var qvClass = 'quickview-open';
        if (target) {
            qvClass = qvClass + '-' + target;
        }
        $el.on('click', function (e) {
            $body.toggleClass(qvClass);
            e.preventDefault();
        });
    };
    __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __decorate */]([
        Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"])(),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __metadata */]("design:type", String)
    ], ToggleQuickviewDirective.prototype, "myToggleQuickview", void 0);
    ToggleQuickviewDirective = __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __decorate */]([
        Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Directive"])({ selector: '[myToggleQuickview]' }),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __metadata */]("design:paramtypes", [__WEBPACK_IMPORTED_MODULE_1__angular_core__["ElementRef"]])
    ], ToggleQuickviewDirective);
    return ToggleQuickviewDirective;
}());


/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(57)))

/***/ }),

/***/ 1328:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AppFooterComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(58);



var AppFooterComponent = /** @class */ (function () {
    function AppFooterComponent() {
    }
    AppFooterComponent.prototype.ngOnInit = function () {
        this.AppConfig = __WEBPACK_IMPORTED_MODULE_2__config__["a" /* APPCONFIG */];
    };
    AppFooterComponent = __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __decorate */]([
        Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Component"])({
            selector: 'my-app-footer',
            styles: [],
            template: __webpack_require__(1329)
        })
    ], AppFooterComponent);
    return AppFooterComponent;
}());



/***/ }),

/***/ 1329:
/***/ (function(module, exports) {

module.exports = "<section class=\"app-footer\">\r\n  <div class=\"container-fluid\">\r\n    <span class=\"float-left\">\r\n      <span>Copyright © {{AppConfig.brand}} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Version {{AppConfig.version}}</span>\r\n    </span>\r\n    <!-- <span class=\"float-right\">\r\n      <span>Built with Love <i class=\"material-icons\">favorite_border</i></span>\r\n    </span> -->\r\n  </div>\r\n</section>\r\n"

/***/ }),

/***/ 1330:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AppSearchOverlayComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__(2);


var AppSearchOverlayComponent = /** @class */ (function () {
    function AppSearchOverlayComponent() {
    }
    AppSearchOverlayComponent = __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __decorate */]([
        Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Component"])({
            selector: 'my-app-search-overlay',
            styles: [],
            template: __webpack_require__(1331)
        })
    ], AppSearchOverlayComponent);
    return AppSearchOverlayComponent;
}());



/***/ }),

/***/ 1331:
/***/ (function(module, exports) {

module.exports = "<section class=\"app-overlay\" mySearchOverlay>\r\n  <div class=\"app-overlay-inner\">\r\n    <div class=\"overlay-header\">\r\n      <a href=\"javascript:;\" id=\"overlay-close\" class=\"overlay-close\">\r\n        <i class=\"material-icons\">close</i>\r\n      </a>\r\n    </div>\r\n    <div class=\"overlay-content\">\r\n      <input id=\"overlay-search-input\"\r\n           class=\"overlay-search-input\" \r\n           placeholder=\"Search...\"\r\n           >\r\n\r\n      <div class=\"text-small text-muted\">\r\n        <span>Press <em>Esc</em> key to dismiss</span>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</section>\r\n"

/***/ }),

/***/ 1332:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SearchOverlayDirective; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__layout_service__ = __webpack_require__(110);



var SearchOverlayDirective = /** @class */ (function () {
    function SearchOverlayDirective(el, layoutService) {
        var _this = this;
        this.el = el;
        this.layoutService = layoutService;
        this.subscription = layoutService.searchOverlayState$.subscribe(function (state) {
            _this.updateSearchOverlay(state);
        });
    }
    SearchOverlayDirective.prototype.ngAfterViewInit = function () {
        var _this = this;
        this.$el = $(this.el.nativeElement);
        this.$body = $('#body');
        this.$searchInput = this.$el.find('#overlay-search-input');
        this.$closeOverlayBtn = this.$el.find('#overlay-close');
        this.$el.on('keyup', function (e) {
            if (e.keyCode === 27) { // when ESC is pressed
                _this.closeOverlay();
            }
        });
        this.$closeOverlayBtn.on('click', function (e) {
            _this.closeOverlay();
            e.preventDefault();
        });
    };
    SearchOverlayDirective.prototype.openOverlay = function () {
        var _this = this;
        this.$body.addClass('overlay-active');
        // [delay] should >= `visibility` transition duration in CSS, see _overlay.scss
        // otherwise auto-focus won't work since element is not there yet
        if (this.$searchInput) {
            setTimeout(function () {
                _this.$searchInput.focus();
            }, 301);
        }
    };
    SearchOverlayDirective.prototype.closeOverlay = function () {
        this.$body.removeClass('overlay-active');
        if (this.$searchInput) {
            this.$searchInput.val(function () {
                return this.defaultValue;
            });
        }
    };
    SearchOverlayDirective.prototype.updateSearchOverlay = function (state) {
        if (state === 'open') {
            this.openOverlay();
        }
    };
    SearchOverlayDirective.prototype.ngOnDestroy = function () {
        this.subscription.unsubscribe();
    };
    SearchOverlayDirective = __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __decorate */]([
        Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Directive"])({ selector: '[mySearchOverlay]' }),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __metadata */]("design:paramtypes", [__WEBPACK_IMPORTED_MODULE_1__angular_core__["ElementRef"], __WEBPACK_IMPORTED_MODULE_2__layout_service__["a" /* LayoutService */]])
    ], SearchOverlayDirective);
    return SearchOverlayDirective;
}());


/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(57)))

/***/ }),

/***/ 1333:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return OpenSearchOverlaylDirective; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__layout_service__ = __webpack_require__(110);



var OpenSearchOverlaylDirective = /** @class */ (function () {
    function OpenSearchOverlaylDirective(el, layoutService) {
        this.el = el;
        this.layoutService = layoutService;
    }
    OpenSearchOverlaylDirective.prototype.ngAfterViewInit = function () {
        var _this = this;
        var $el = $(this.el.nativeElement);
        var $body = $('#body');
        $el.on('click', function (e) {
            _this.openOverlay();
        });
    };
    OpenSearchOverlaylDirective.prototype.openOverlay = function () {
        this.layoutService.updateSearchOverlayState('open');
    };
    OpenSearchOverlaylDirective = __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __decorate */]([
        Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Directive"])({ selector: '[myOpenSearchOverlay]' }),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __metadata */]("design:paramtypes", [__WEBPACK_IMPORTED_MODULE_1__angular_core__["ElementRef"], __WEBPACK_IMPORTED_MODULE_2__layout_service__["a" /* LayoutService */]])
    ], OpenSearchOverlaylDirective);
    return OpenSearchOverlaylDirective;
}());


/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(57)))

/***/ }),

/***/ 280:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SharedModule; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__echarts_directive__ = __webpack_require__(1010);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__slim_scroll_directive__ = __webpack_require__(1301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__directives_file_drop__ = __webpack_require__(1303);





var SharedModule = /** @class */ (function () {
    function SharedModule() {
    }
    SharedModule = __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __decorate */]([
        Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["NgModule"])({
            imports: [],
            declarations: [
                __WEBPACK_IMPORTED_MODULE_2__echarts_directive__["a" /* EChartsDirective */],
                __WEBPACK_IMPORTED_MODULE_3__slim_scroll_directive__["a" /* SlimScrollDirective */],
                __WEBPACK_IMPORTED_MODULE_4__directives_file_drop__["a" /* FileDropDirective */]
            ],
            exports: [
                __WEBPACK_IMPORTED_MODULE_2__echarts_directive__["a" /* EChartsDirective */],
                __WEBPACK_IMPORTED_MODULE_3__slim_scroll_directive__["a" /* SlimScrollDirective */],
                __WEBPACK_IMPORTED_MODULE_4__directives_file_drop__["a" /* FileDropDirective */]
            ]
        })
    ], SharedModule);
    return SharedModule;
}());



/***/ }),

/***/ 282:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AuthGuardService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_router__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__angular_material__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__layout_restrictedAccesss_component__ = __webpack_require__(444);







var AuthGuardService = /** @class */ (function () {
    function AuthGuardService(router, api, dialog) {
        this.router = router;
        this.api = api;
        this.dialog = dialog;
    }
    AuthGuardService.prototype.canLoad = function (route) {
        console.log("inside canLoad", route);
        if (localStorage.getItem(__WEBPACK_IMPORTED_MODULE_5__config__["a" /* APPCONFIG */].prefix + 'isLoggedIn') && localStorage.getItem(__WEBPACK_IMPORTED_MODULE_5__config__["a" /* APPCONFIG */].prefix + 'isLoggedIn') == 'true') {
            console.log("inside loading permission");
            return true;
        }
        console.log("user is not logged in for guard");
        return false;
    };
    AuthGuardService.prototype.canActivate = function (route, state) {
        // alert("activate route snap shot "  + ActivatedRouteSnapshot + " RouterStateSnapshot " + RouterStateSnapshot  ) ;
        var url = state.url;
        console.log('Url:' + url);
        if (this.api.isloggedInUserAdmin()) {
            console.log("activated Route");
            return true;
        }
        console.log("Deactivated Route");
        this.dialog.open(__WEBPACK_IMPORTED_MODULE_6__layout_restrictedAccesss_component__["a" /* RestrictedAccessComponent */]);
        return false;
    };
    AuthGuardService = __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __decorate */]([
        Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Injectable"])(),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __metadata */]("design:paramtypes", [__WEBPACK_IMPORTED_MODULE_2__angular_router__["f" /* Router */], __WEBPACK_IMPORTED_MODULE_4__api__["a" /* Api */], __WEBPACK_IMPORTED_MODULE_3__angular_material__["i" /* MatDialog */]])
    ], AuthGuardService);
    return AuthGuardService;
}());



/***/ }),

/***/ 329:
/***/ (function(module, exports) {

function webpackEmptyAsyncContext(req) {
	// Here Promise.resolve().then() is used instead of new Promise() to prevent
	// uncatched exception popping up in devtools
	return Promise.resolve().then(function() {
		throw new Error("Cannot find module '" + req + "'.");
	});
}
webpackEmptyAsyncContext.keys = function() { return []; };
webpackEmptyAsyncContext.resolve = webpackEmptyAsyncContext;
module.exports = webpackEmptyAsyncContext;
webpackEmptyAsyncContext.id = 329;

/***/ }),

/***/ 363:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PageLayoutFullscreenComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__(2);


// Children of AppModule instead of AppMainModule
var PageLayoutFullscreenComponent = /** @class */ (function () {
    function PageLayoutFullscreenComponent() {
    }
    PageLayoutFullscreenComponent = __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __decorate */]([
        Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Component"])({
            selector: 'my-page-layout-fullscreen',
            styles: [],
            template: __webpack_require__(748)
        })
    ], PageLayoutFullscreenComponent);
    return PageLayoutFullscreenComponent;
}());



/***/ }),

/***/ 364:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LayoutModule", function() { return LayoutModule; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__layout_routing_module__ = __webpack_require__(749);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_shared_module__ = __webpack_require__(280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_ng2_toastr__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_ng2_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_ng2_toastr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__layout_restrictedAccesss_component__ = __webpack_require__(444);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__angular_material__ = __webpack_require__(120);







var LayoutModule = /** @class */ (function () {
    function LayoutModule() {
    }
    LayoutModule = __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __decorate */]([
        Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["NgModule"])({
            imports: [
                __WEBPACK_IMPORTED_MODULE_6__angular_material__["c" /* MatButtonModule */],
                __WEBPACK_IMPORTED_MODULE_2__layout_routing_module__["a" /* LayoutRoutingModule */],
                __WEBPACK_IMPORTED_MODULE_3__shared_shared_module__["a" /* SharedModule */],
                __WEBPACK_IMPORTED_MODULE_4_ng2_toastr__["ToastModule"].forRoot(),
            ],
            declarations: [__WEBPACK_IMPORTED_MODULE_5__layout_restrictedAccesss_component__["a" /* RestrictedAccessComponent */]],
            entryComponents: [__WEBPACK_IMPORTED_MODULE_5__layout_restrictedAccesss_component__["a" /* RestrictedAccessComponent */]]
        })
    ], LayoutModule);
    return LayoutModule;
}());



/***/ }),

/***/ 444:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RestrictedAccessComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_material__ = __webpack_require__(120);



// openDialogWithAResult
var RestrictedAccessComponent = /** @class */ (function () {
    function RestrictedAccessComponent(dialogRef) {
        this.dialogRef = dialogRef;
    }
    RestrictedAccessComponent = __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __decorate */]([
        Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Component"])({
            selector: 'restricted-access',
            template: "<h4 md-dialog-title style=\"align-items: center\">Restricted Access!</h4>\n    <div md-dialog-content style=\"padding-bottom: 20px;\">Only Admins are allowed to navigate into this section? </div>\n    <div md-dialog-actions>\n          <button mat-raised-button   (click)=\"dialogRef.close()\">OK</button>\n    </div>",
        }),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __metadata */]("design:paramtypes", [__WEBPACK_IMPORTED_MODULE_2__angular_material__["k" /* MatDialogRef */]])
    ], RestrictedAccessComponent);
    return RestrictedAccessComponent;
}());



/***/ }),

/***/ 445:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LayoutComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ng2_toastr__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ng2_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_ng2_toastr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_angular2_json2csv__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_angular2_json2csv___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_angular2_json2csv__);






var LayoutComponent = /** @class */ (function () {
    function LayoutComponent(toastr, vcr) {
        this.toastr = toastr;
        this.logedin = false;
        this.toastr.setRootViewContainerRef(vcr);
        var lg = this.getIsLoggedIn();
        if (lg && lg == 'true') {
            this.logedin = true;
        }
        else {
            this.logedin = false;
        }
    }
    LayoutComponent.prototype.getIsLoggedIn = function () {
        return localStorage.getItem(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* APPCONFIG */].prefix + "isLoggedIn");
    };
    LayoutComponent = __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __decorate */]([
        Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Component"])({
            selector: 'my-app-layout',
            template: __webpack_require__(1004),
            providers: [__WEBPACK_IMPORTED_MODULE_4_angular2_json2csv__["CsvService"]]
        }),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __metadata */]("design:paramtypes", [__WEBPACK_IMPORTED_MODULE_2_ng2_toastr__["ToastsManager"], __WEBPACK_IMPORTED_MODULE_1__angular_core__["ViewContainerRef"]])
    ], LayoutComponent);
    return LayoutComponent;
}());



/***/ }),

/***/ 527:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ApiBilling; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_http__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_core__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rxjs_add_operator_map__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rxjs_add_operator_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_rxjs_add_operator_map__);




var ApiBilling = /** @class */ (function () {
    function ApiBilling(http) {
        this.http = http;
        this.setURLS();
    }
    ApiBilling.prototype.get = function (endpoint, params, reqOpts) {
        if (!reqOpts) {
            reqOpts = new __WEBPACK_IMPORTED_MODULE_1__angular_http__["e" /* RequestOptions */]();
        }
        // {headers: new HttpHeaders({'Content-Type': 'application/json'})}
        // Support easy query params for GET requests
        if (params) {
            reqOpts.params = new URLSearchParams();
            for (var k in params) {
                reqOpts.params.set(k, params[k]);
            }
        }
        return this.http.get(this.url + '/' + endpoint, reqOpts);
    };
    ApiBilling.prototype.post = function (endpoint, body, reqOpts) {
        return this.http.post(this.url + '/' + endpoint, body, reqOpts);
    };
    ApiBilling.prototype.put = function (endpoint, body, reqOpts) {
        return this.http.put(this.url + '/' + endpoint, body, reqOpts);
    };
    ApiBilling.prototype.delete = function (endpoint, reqOpts) {
        return this.http.delete(this.url + '/' + endpoint, reqOpts);
    };
    ApiBilling.prototype.patch = function (endpoint, body, reqOpts) {
        return this.http.put(this.url + '/' + endpoint, body, reqOpts);
    };
    ApiBilling.prototype.setURLS = function () {
        this.url = localStorage.getItem("billingApiUrl");
    };
    ApiBilling = __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __decorate */]([
        Object(__WEBPACK_IMPORTED_MODULE_2__angular_core__["Injectable"])(),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __metadata */]("design:paramtypes", [__WEBPACK_IMPORTED_MODULE_1__angular_http__["b" /* Http */]])
    ], ApiBilling);
    return ApiBilling;
}());



/***/ }),

/***/ 58:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return APPCONFIG; });
function makeAppConfig() {
    var date = new Date();
    var year = date.getFullYear();
    var GA_MK_version = "1.1.8";
    var AppConfig = {
        salesKey: "123",
        // TODO: local urls
        //imagesBaseUrl: "https://anydatapoint.net/",
        imagesBaseUrl: "http://dev.cdn01.anydatapoint.com",
        brandingFolder: "branding",
        /* ****************************************************************************
         *                                                                            *
         *    Set Following Variable for the LOCAL, DEV and COMMERCIAL environment    *
         *                      0                                                      *
         * ****************************************************************************/
        ENVIRONMENT: "DEV",
        // SERVER_REGION:'', //Possible-Values ['PK', 'NA',]
        /*URL Set For Local Environment*/
        // LOCAL_DTAPI_PK:"http://localhost:8089/api/v1",
        // LOCAL_RTAPI_PK:"http://dev.rtapi.jazzba.io/api/v2",
        //
        // LOCAL_DTAPI_NA:"http://localhost:8089/api/v1",
        // LOCAL_RTAPI_NA:"http://dev.rtapi.jazzba.io/api/v2",
        // LOCAL_RA_SERVICE:"http://localhost:8089/api/v1",
        LOCAL_RA_SERVICE: "http://dev.raservice.jazzba.io/",
        // LOCAL_RA_SERVICE:"http://localhost:8089/api/v1",
        //LOCAL_RA_SERVICE:"http://dev.raservice.jazzba.io/",
        /*URL Set For DEV Environment*/
        // DEV_DTAPI_PK:"http://dev.dtapipk.jazzba.io/api/v1",
        // DEV_RTAPI_PK:"http://dev.rtapipk.jazzba.io/api/v2",
        //
        // DEV_DTAPI_NA:"http://dev.dtapi.jazzba.io/api/v1",
        // DEV_RTAPI_NA:"http://dev.rtapi.jazzba.io/api/v2",
        DEV_RA_SERVICE: "http://dev.raservice.jazzba.io/",
        /*URL Set For COMMERCIAL Environment*/
        // COMMERCIAL_DTAPI_PK:"https://dtapipk.jazzba.io/api/v1",
        // COMMERCIAL_RTAPI_PK:"https://rtapipk.jazzba.io/api/v2",
        //
        // COMMERCIAL_DTAPI_NA:"https://dtapina.jazzba.io/api/v1",
        // COMMERCIAL_RTAPI_NA:"https://rtapina.jazzba.io/api/v2",
        COMMERCIAL_RA_SERVICE: "https://raservice.jazzba.io/",
        // RUNTIME_API_PK: "http://dev.dtapipk.jazzba.io/api/v1",
        // RUNTIME_API_NA: "https://dev.dtapina.jazzba.io/api/v1",
        // RA_SERVICE_API: "http://raservice.jazzba.io/",
        // RUNTIME_API_PK: "http://localhost:8089/api/v1",
        // RUNTIME_API_NA: "http://localhost:8089/api/v1",
        RA_SERVICE_API: "http://raservice.jazzba.io/",
        // LOCAL_ApiURL_billing: "http://dev.adppay.jazzba.io/api/v1",     //todo  Billing URLS are no more needed as these are also received from RAService Upon Login
        // DEV_ApiURL_billing: "http://dev.adppay.jazzba.io/api/v1",
        // COMMERCIAL_ApiURL_billing: "http://adppay.jazzba.io/api/v1",
        // DEV_NA_imageUploderURL:'http://dev.imageuploaderna.jazzba.io/upload.php',
        // DEV_PK_imageUploderURL:'http://dev.imageuploaderpk.jazzba.io/upload.php',
        //
        // DEV_PK_imageStatsURL:'http://dev.imageuploaderpk.jazzba.io/imagecheck.php',
        // DEV_NA_imageStatsURL:'http://dev.imageuploaderna.jazzba.io/imagecheck.php',
        //
        // COMMERCIAL_NA_imageUploderURL:'https://imageuploaderna.jazzba.io/upload.php',
        // COMMERCIAL_PK_imageUploderURL:'https://imageuploaderpk.jazzba.io/upload.php',
        //
        // COMMERCIAL_PK_imageStatsURL:'https://imageuploaderpk.jazzba.io/imagecheck.php',
        // COMMERCIAL_NA_imageStatsURL:'https://imageuploaderna.jazzba.io/imagecheck.php',
        //
        // LOCAL_NA_imageUploderURL:'http://dev.imageuploaderna.jazzba.io/upload.php',
        // LOCAL_PK_imageUploderURL:'http://dev.imageuploaderna.jazzba.io/upload.php',
        //
        // LOCAL_PK_imageStatsURL:'http://dev.imageuploaderpk.jazzba.io/imagecheck.php',
        // LOCAL_NA_imageStatsURL:'http://dev.imageuploaderna.jazzba.io/imagecheck.php',
        //imageUploderURL:"http://adp-imageuploader.anydatapoint.com/upload.php",
        //imageStatsURL:"http://adp-imageuploader.anydatapoint.com/imagecheck.php",
        //ApiURL: "http://dev.dtapi.jazzba.io/api/v1", 
        //  ApiURL: "http://localhost:8089/api/v1",
        // ApiURL_billing: "http://69.64.55.113:6010/ADPPAYServer/api/v1",
        // ApiURL_billing: "http://dev.adppay.anydatapoint.com/ADPPAYServer/api/v1",
        // ApiURL_billing: "http://dev.adppay.anydatapoint.com/api/v1",
        // todo  May 28 2019  by NH AR and NR
        //  On login the response object will bring the end points [rtapi,dtapi,billingapi] that needs to set for url  of user
        ApiURL_billing: "http://dev.adppay.jazzba.io/api/v1",
        ApiURL_dt: "http://dev.dtapi.jazzba.io/api/v1",
        // java_image_uploader_url : "http://localhost:8087/api/v1",
        java_image_uploader_url: "http://dev.imageuploaderca.jazzba.io/api/v1",
        Monthly_License_alias: "ims",
        webStore_License_alias: "ws",
        WebStore_License_price: 500,
        InventoryManagement_License_price: 500,
        EDI_Integrations_License_price: 0.6,
        EDI_Integrations_License_alias: "integrations-edi",
        chargebeeSiteName: "jazzba-test",
        chargebeeSiteApiKKey: "test_0cuwA2FnHWUS4ALkB9DitT8RByMre8ZFe",
        // ApiURL_billing: "localhost:8080/api/v1",
        // ADP_API_BASE_URL : "http://dev.rtapi.jazzba.io/api/v2",
        prefix: "local",
        //Todo we want api  route grouping based on module[e.g intellicommerce intellistock, intellicatalog]?, version?, region, application server URLs
        // jazzba global scripts ++zopim
        zopim_subdomain: 'whiztec.zendesk.com',
        //TODO: Dev urls
        // imagesBaseUrl:"https://anydatapoint.net",
        // brandingFolder:"branding",
        // imageUploderURL:"http://69.64.55.113:88/adp-imageuploader/upload.php",
        // imageStatsURL:"http://69.64.55.113:88/adp-imageuploader/imagecheck.php",
        // ApiURL:"http://dev.manageapi.jazzba.io/api/v1",
        // ApiURL:"http://localhost:8089/api/v1",
        // ADP_API_BASE_URL:"http://dev.adp-server.anydatapoint.com/api/v2",
        // prefix : "dev",
        // imagesBaseUrl:"https://anydatapoint.net",
        // brandingFolder:"branding",
        // imageUploderURL:"http://adp-imageuploader.anydatapoint.com/upload.php",
        // imageStatsURL:"http://adp-imageuploader.anydatapoint.com/imagecheck.php",
        // ApiURL:"http://manageapi.jazzba.io/api/v1",
        // ADP_API_BASE_URL:"https://adp-server.anydatapoint.com/api/v2",
        // prefix : "comm",
        // storeURL : "https://intellicommerce.anydatapoint.com/?custId=",
        storeURL: "http://dev.intellicommerce.jazzba.io/?custId=",
        imageCutterSizes: "80x80,400x400",
        brand: 'Jazzba Inc.',
        version: "2.5.216",
        user: 'Lisa',
        year: year,
        layoutBoxed: false,
        navCollapsed: false,
        navBehind: false,
        fixedHeader: false,
        sidebarWidth: 'middle',
        theme: 'light',
        colorOption: '11',
        AutoCloseMobileNav: true,
        productLink: '#'
        // productLink: 'https://themeforest.net/item/material-design-angular-2-admin-web-app-with-bootstrap-4/19421267'
    };
    return AppConfig;
}
var APPCONFIG = makeAppConfig();


/***/ }),

/***/ 699:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["main"] = main;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_platform_browser_dynamic__ = __webpack_require__(702);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__app_app_module__ = __webpack_require__(703);



// depending on the env mode, enable prod mode or add debugging modules
if (true) {
    Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["enableProdMode"])();
}
function main() {
    return Object(__WEBPACK_IMPORTED_MODULE_1__angular_platform_browser_dynamic__["a" /* platformBrowserDynamic */])().bootstrapModule(__WEBPACK_IMPORTED_MODULE_2__app_app_module__["a" /* AppModule */]);
}
if (document.readyState === 'complete') {
    main();
}
else {
    document.addEventListener('DOMContentLoaded', main);
}


/***/ }),

/***/ 703:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ZendeskConfig */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AppModule; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__raven__ = __webpack_require__(704);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_core__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__angular_platform_browser__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__angular_http__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__angular_forms__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__angular_platform_browser_animations__ = __webpack_require__(712);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__angular_material__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__app_routing_module__ = __webpack_require__(747);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__app_component__ = __webpack_require__(1305);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__layout_layout_component__ = __webpack_require__(445);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__layout_preloader_directive__ = __webpack_require__(1313);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__layout_header_header_component__ = __webpack_require__(1314);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__layout_sidenav_sidenav_component__ = __webpack_require__(1316);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__layout_sidenav_toggle_offcanvas_nav_directive__ = __webpack_require__(1318);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__layout_sidenav_auto_close_mobile_nav_directive__ = __webpack_require__(1319);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__layout_sidenav_sidenav_menu_sidenav_menu_component__ = __webpack_require__(1320);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__layout_sidenav_sidenav_menu_accordion_nav_directive__ = __webpack_require__(1322);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__layout_sidenav_sidenav_menu_append_submenu_icon_directive__ = __webpack_require__(1323);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__layout_sidenav_sidenav_menu_highlight_active_items_directive__ = __webpack_require__(1324);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__layout_customizer_customizer_component__ = __webpack_require__(1325);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__layout_customizer_toggle_quickview_directive__ = __webpack_require__(1327);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__layout_footer_footer_component__ = __webpack_require__(1328);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__layout_search_overlay_search_overlay_component__ = __webpack_require__(1330);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__layout_search_overlay_search_overlay_directive__ = __webpack_require__(1332);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__layout_search_overlay_open_search_overlay_directive__ = __webpack_require__(1333);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__page_layouts_fullscreen_fullscreen_component__ = __webpack_require__(363);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__layout_layout_module__ = __webpack_require__(364);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__shared_shared_module__ = __webpack_require__(280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__angularclass_hmr__ = __webpack_require__(1334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__angularclass_hmr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29__angularclass_hmr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__providers_api__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__providers_api_billing__ = __webpack_require__(527);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__providers_auth_guard_service__ = __webpack_require__(282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__config__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34_angular2_text_mask__ = __webpack_require__(529);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34_angular2_text_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_34_angular2_text_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35_ng2_toastr__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35_ng2_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_35_ng2_toastr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36_angular2_json2csv__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36_angular2_json2csv___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_36_angular2_json2csv__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37_angular2_busy__ = __webpack_require__(525);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37_angular2_busy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_37_angular2_busy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__toverux_ngx_sweetalert2__ = __webpack_require__(534);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39_ngx_zendesk_webwidget__ = __webpack_require__(284);






// import {NgxImageSwapModule} from 'ngx-image-swap';




// Layout


// Header

// Sidenav







// Customizer


// Footer

// Search Overaly



// Pages

// Sub modules


// hmr

// Providers




// import { FileDropModule } from 'ngx-file-drop/lib/ngx-drop';






var ZendeskConfig = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */](ZendeskConfig, _super);
    function ZendeskConfig() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.accountUrl = __WEBPACK_IMPORTED_MODULE_33__config__["a" /* APPCONFIG */].zopim_subdomain;
        return _this;
    }
    ZendeskConfig.prototype.beforePageLoad = function (zE) {
        zE.setLocale('en');
        zE.hide();
        zE.setHelpCenterSuggestions({ url: true });
    };
    return ZendeskConfig;
}(__WEBPACK_IMPORTED_MODULE_39_ngx_zendesk_webwidget__["a" /* ngxZendeskWebwidgetConfig */]));

var AppModule = /** @class */ (function () {
    function AppModule(appRef) {
        this.appRef = appRef;
    }
    AppModule.prototype.hmrOnInit = function (store) {
        console.log('HMR store', store);
    };
    AppModule.prototype.hmrOnDestroy = function (store) {
        var cmpLocation = this.appRef.components.map(function (cmp) { return cmp.location.nativeElement; });
        // recreate elements
        store.disposeOldHosts = Object(__WEBPACK_IMPORTED_MODULE_29__angularclass_hmr__["createNewHosts"])(cmpLocation);
        // remove styles
        Object(__WEBPACK_IMPORTED_MODULE_29__angularclass_hmr__["removeNgStyles"])();
    };
    AppModule.prototype.hmrAfterDestroy = function (store) {
        // display new elements
        store.disposeOldHosts();
        delete store.disposeOldHosts;
    };
    AppModule = __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __decorate */]([
        Object(__WEBPACK_IMPORTED_MODULE_2__angular_core__["NgModule"])({
            imports: [
                __WEBPACK_IMPORTED_MODULE_39_ngx_zendesk_webwidget__["b" /* ngxZendeskWebwidgetModule */].forRoot(ZendeskConfig),
                __WEBPACK_IMPORTED_MODULE_3__angular_platform_browser__["BrowserModule"],
                __WEBPACK_IMPORTED_MODULE_4__angular_http__["c" /* HttpModule */],
                __WEBPACK_IMPORTED_MODULE_5__angular_forms__["FormsModule"],
                __WEBPACK_IMPORTED_MODULE_34_angular2_text_mask__["TextMaskModule"],
                __WEBPACK_IMPORTED_MODULE_5__angular_forms__["ReactiveFormsModule"],
                __WEBPACK_IMPORTED_MODULE_6__angular_platform_browser_animations__["a" /* BrowserAnimationsModule */],
                __WEBPACK_IMPORTED_MODULE_7__angular_material__["b" /* MatAutocompleteModule */],
                __WEBPACK_IMPORTED_MODULE_7__angular_material__["c" /* MatButtonModule */],
                __WEBPACK_IMPORTED_MODULE_7__angular_material__["d" /* MatButtonToggleModule */],
                __WEBPACK_IMPORTED_MODULE_7__angular_material__["e" /* MatCardModule */],
                __WEBPACK_IMPORTED_MODULE_7__angular_material__["f" /* MatCheckboxModule */],
                __WEBPACK_IMPORTED_MODULE_7__angular_material__["g" /* MatChipsModule */],
                __WEBPACK_IMPORTED_MODULE_7__angular_material__["F" /* MatStepperModule */],
                __WEBPACK_IMPORTED_MODULE_7__angular_material__["h" /* MatDatepickerModule */],
                __WEBPACK_IMPORTED_MODULE_7__angular_material__["j" /* MatDialogModule */],
                __WEBPACK_IMPORTED_MODULE_7__angular_material__["l" /* MatExpansionModule */],
                __WEBPACK_IMPORTED_MODULE_7__angular_material__["m" /* MatGridListModule */],
                __WEBPACK_IMPORTED_MODULE_7__angular_material__["n" /* MatIconModule */],
                __WEBPACK_IMPORTED_MODULE_7__angular_material__["o" /* MatInputModule */],
                __WEBPACK_IMPORTED_MODULE_7__angular_material__["p" /* MatListModule */],
                __WEBPACK_IMPORTED_MODULE_7__angular_material__["q" /* MatMenuModule */],
                __WEBPACK_IMPORTED_MODULE_7__angular_material__["r" /* MatNativeDateModule */],
                __WEBPACK_IMPORTED_MODULE_7__angular_material__["t" /* MatPaginatorModule */],
                __WEBPACK_IMPORTED_MODULE_7__angular_material__["u" /* MatProgressBarModule */],
                __WEBPACK_IMPORTED_MODULE_7__angular_material__["v" /* MatProgressSpinnerModule */],
                __WEBPACK_IMPORTED_MODULE_7__angular_material__["w" /* MatRadioModule */],
                __WEBPACK_IMPORTED_MODULE_7__angular_material__["x" /* MatRippleModule */],
                __WEBPACK_IMPORTED_MODULE_7__angular_material__["y" /* MatSelectModule */],
                __WEBPACK_IMPORTED_MODULE_7__angular_material__["z" /* MatSidenavModule */],
                __WEBPACK_IMPORTED_MODULE_7__angular_material__["B" /* MatSliderModule */],
                __WEBPACK_IMPORTED_MODULE_7__angular_material__["A" /* MatSlideToggleModule */],
                __WEBPACK_IMPORTED_MODULE_7__angular_material__["D" /* MatSnackBarModule */],
                __WEBPACK_IMPORTED_MODULE_7__angular_material__["E" /* MatSortModule */],
                __WEBPACK_IMPORTED_MODULE_7__angular_material__["G" /* MatTableModule */],
                __WEBPACK_IMPORTED_MODULE_7__angular_material__["H" /* MatTabsModule */],
                __WEBPACK_IMPORTED_MODULE_7__angular_material__["I" /* MatToolbarModule */],
                __WEBPACK_IMPORTED_MODULE_7__angular_material__["J" /* MatTooltipModule */],
                __WEBPACK_IMPORTED_MODULE_8__app_routing_module__["a" /* AppRoutingModule */],
                __WEBPACK_IMPORTED_MODULE_35_ng2_toastr__["ToastModule"].forRoot(),
                // Sub modules
                __WEBPACK_IMPORTED_MODULE_27__layout_layout_module__["LayoutModule"],
                __WEBPACK_IMPORTED_MODULE_28__shared_shared_module__["a" /* SharedModule */],
                __WEBPACK_IMPORTED_MODULE_37_angular2_busy__["BusyModule"],
                __WEBPACK_IMPORTED_MODULE_38__toverux_ngx_sweetalert2__["a" /* SweetAlert2Module */].forRoot(),
            ],
            declarations: [
                __WEBPACK_IMPORTED_MODULE_9__app_component__["a" /* AppComponent */],
                // Layout
                __WEBPACK_IMPORTED_MODULE_10__layout_layout_component__["a" /* LayoutComponent */],
                __WEBPACK_IMPORTED_MODULE_11__layout_preloader_directive__["a" /* PreloaderDirective */],
                // Header
                __WEBPACK_IMPORTED_MODULE_12__layout_header_header_component__["a" /* AppHeaderComponent */],
                // Sidenav
                __WEBPACK_IMPORTED_MODULE_13__layout_sidenav_sidenav_component__["a" /* AppSidenavComponent */],
                __WEBPACK_IMPORTED_MODULE_14__layout_sidenav_toggle_offcanvas_nav_directive__["a" /* ToggleOffcanvasNavDirective */],
                __WEBPACK_IMPORTED_MODULE_15__layout_sidenav_auto_close_mobile_nav_directive__["a" /* AutoCloseMobileNavDirective */],
                __WEBPACK_IMPORTED_MODULE_16__layout_sidenav_sidenav_menu_sidenav_menu_component__["a" /* AppSidenavMenuComponent */],
                __WEBPACK_IMPORTED_MODULE_17__layout_sidenav_sidenav_menu_accordion_nav_directive__["a" /* AccordionNavDirective */],
                __WEBPACK_IMPORTED_MODULE_18__layout_sidenav_sidenav_menu_append_submenu_icon_directive__["a" /* AppendSubmenuIconDirective */],
                __WEBPACK_IMPORTED_MODULE_19__layout_sidenav_sidenav_menu_highlight_active_items_directive__["a" /* HighlightActiveItemsDirective */],
                // Customizer
                __WEBPACK_IMPORTED_MODULE_20__layout_customizer_customizer_component__["a" /* AppCustomizerComponent */],
                __WEBPACK_IMPORTED_MODULE_21__layout_customizer_toggle_quickview_directive__["a" /* ToggleQuickviewDirective */],
                // Footer
                __WEBPACK_IMPORTED_MODULE_22__layout_footer_footer_component__["a" /* AppFooterComponent */],
                // Search overlay
                __WEBPACK_IMPORTED_MODULE_23__layout_search_overlay_search_overlay_component__["a" /* AppSearchOverlayComponent */],
                __WEBPACK_IMPORTED_MODULE_24__layout_search_overlay_search_overlay_directive__["a" /* SearchOverlayDirective */],
                __WEBPACK_IMPORTED_MODULE_25__layout_search_overlay_open_search_overlay_directive__["a" /* OpenSearchOverlaylDirective */],
                //
                // Pages
                __WEBPACK_IMPORTED_MODULE_26__page_layouts_fullscreen_fullscreen_component__["a" /* PageLayoutFullscreenComponent */]
            ],
            bootstrap: [__WEBPACK_IMPORTED_MODULE_9__app_component__["a" /* AppComponent */]],
            providers: [{ provide: __WEBPACK_IMPORTED_MODULE_2__angular_core__["ErrorHandler"], useClass: __WEBPACK_IMPORTED_MODULE_1__raven__["a" /* RavenErrorHandler */] }, __WEBPACK_IMPORTED_MODULE_36_angular2_json2csv__["CsvService"], __WEBPACK_IMPORTED_MODULE_31__providers_api_billing__["a" /* ApiBilling */], __WEBPACK_IMPORTED_MODULE_30__providers_api__["a" /* Api */], __WEBPACK_IMPORTED_MODULE_32__providers_auth_guard_service__["a" /* AuthGuardService */]]
        }),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __metadata */]("design:paramtypes", [__WEBPACK_IMPORTED_MODULE_2__angular_core__["ApplicationRef"]])
    ], AppModule);
    return AppModule;
}());



/***/ }),

/***/ 704:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RavenErrorHandler; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_raven_js__ = __webpack_require__(705);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_raven_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_raven_js__);

__WEBPACK_IMPORTED_MODULE_0_raven_js__["config"]('https://18926e522d6244e28cd2180a6e7d8965@sentry.io/253371')
    .install();
var RavenErrorHandler = /** @class */ (function () {
    function RavenErrorHandler() {
    }
    RavenErrorHandler.prototype.handleError = function (err) {
        console.error(err);
        __WEBPACK_IMPORTED_MODULE_0_raven_js__["captureException"](err);
    };
    return RavenErrorHandler;
}());



/***/ }),

/***/ 747:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AppRoutingModule; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_router__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__page_layouts_fullscreen_fullscreen_component__ = __webpack_require__(363);

// Page Layouts

var AppRoutes = [
    { path: '', redirectTo: '/extra/login', pathMatch: 'full' },
    // { path: 'app', component: LayoutComponent },
    { path: 'app', loadChildren: function() { return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 364))  .then( function(module) { return module['LayoutModule']; } ); } },
    { path: 'extra', loadChildren: function() { return __webpack_require__.e/* import() */(17).then(__webpack_require__.bind(null, 1363))  .then( function(module) { return module['ExtraPagesModule']; } ); } },
    { path: 'fullscreen', component: __WEBPACK_IMPORTED_MODULE_1__page_layouts_fullscreen_fullscreen_component__["a" /* PageLayoutFullscreenComponent */] },
];
var AppRoutingModule = __WEBPACK_IMPORTED_MODULE_0__angular_router__["g" /* RouterModule */].forRoot(AppRoutes, { useHash: true });


/***/ }),

/***/ 748:
/***/ (function(module, exports) {

module.exports = "<section class=\"container-fluid\">\r\n\r\n  <div class=\"article-title\">Blank</div>\r\n\r\n</section>"

/***/ }),

/***/ 749:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LayoutRoutingModule; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_router__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__providers_auth_guard_service__ = __webpack_require__(282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__layout_component__ = __webpack_require__(445);



var routes = [
    {
        path: 'app',
        component: __WEBPACK_IMPORTED_MODULE_2__layout_component__["a" /* LayoutComponent */],
        children: [
            { path: '', redirectTo: '/app/dashboard', pathMatch: 'full', canActivate: [__WEBPACK_IMPORTED_MODULE_1__providers_auth_guard_service__["a" /* AuthGuardService */]], canLoad: [__WEBPACK_IMPORTED_MODULE_1__providers_auth_guard_service__["a" /* AuthGuardService */]] },
            { path: 'dashboard', loadChildren: function() { return __webpack_require__.e/* import() */(20).then(__webpack_require__.bind(null, 1340))  .then( function(module) { return module['DashboardModule']; } ); }, canActivate: [__WEBPACK_IMPORTED_MODULE_1__providers_auth_guard_service__["a" /* AuthGuardService */]], canLoad: [__WEBPACK_IMPORTED_MODULE_1__providers_auth_guard_service__["a" /* AuthGuardService */]] },
            { path: 'blank', loadChildren: function() { return __webpack_require__.e/* import() */(13).then(__webpack_require__.bind(null, 1341))  .then( function(module) { return module['BlankModule']; } ); }, canActivate: [__WEBPACK_IMPORTED_MODULE_1__providers_auth_guard_service__["a" /* AuthGuardService */]], canLoad: [__WEBPACK_IMPORTED_MODULE_1__providers_auth_guard_service__["a" /* AuthGuardService */]] },
            { path: 'billing', loadChildren: function() { return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, 1342))  .then( function(module) { return module['BillingModule']; } ); }, canActivate: [__WEBPACK_IMPORTED_MODULE_1__providers_auth_guard_service__["a" /* AuthGuardService */]], canLoad: [__WEBPACK_IMPORTED_MODULE_1__providers_auth_guard_service__["a" /* AuthGuardService */]] },
            { path: 'integrations', loadChildren: function() { return __webpack_require__.e/* import() */(12).then(__webpack_require__.bind(null, 1343))  .then( function(module) { return module['IntegrationsModule']; } ); }, canActivate: [__WEBPACK_IMPORTED_MODULE_1__providers_auth_guard_service__["a" /* AuthGuardService */]], canLoad: [__WEBPACK_IMPORTED_MODULE_1__providers_auth_guard_service__["a" /* AuthGuardService */]] },
            { path: 'transactions', loadChildren: function() { return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 1344))  .then( function(module) { return module['TransectionsModule']; } ); }, canActivate: [__WEBPACK_IMPORTED_MODULE_1__providers_auth_guard_service__["a" /* AuthGuardService */]], canLoad: [__WEBPACK_IMPORTED_MODULE_1__providers_auth_guard_service__["a" /* AuthGuardService */]] },
            { path: 'lookups', loadChildren: function() { return __webpack_require__.e/* import() */(9).then(__webpack_require__.bind(null, 1345))  .then( function(module) { return module['LookupsModule']; } ); }, canActivate: [__WEBPACK_IMPORTED_MODULE_1__providers_auth_guard_service__["a" /* AuthGuardService */]], canLoad: [__WEBPACK_IMPORTED_MODULE_1__providers_auth_guard_service__["a" /* AuthGuardService */]] },
            { path: 'company', loadChildren: function() { return __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, 1346))  .then( function(module) { return module['TransectionsModule']; } ); }, canActivate: [__WEBPACK_IMPORTED_MODULE_1__providers_auth_guard_service__["a" /* AuthGuardService */]], canLoad: [__WEBPACK_IMPORTED_MODULE_1__providers_auth_guard_service__["a" /* AuthGuardService */]] },
            { path: 'users', loadChildren: function() { return __webpack_require__.e/* import() */(4).then(__webpack_require__.bind(null, 1347))  .then( function(module) { return module['UsersModule']; } ); }, canActivate: [__WEBPACK_IMPORTED_MODULE_1__providers_auth_guard_service__["a" /* AuthGuardService */]], canLoad: [__WEBPACK_IMPORTED_MODULE_1__providers_auth_guard_service__["a" /* AuthGuardService */]] },
            { path: 'buy-supply', loadChildren: function() { return __webpack_require__.e/* import() */(5).then(__webpack_require__.bind(null, 1348))  .then( function(module) { return module['BuyerSupplierModule']; } ); }, canActivate: [__WEBPACK_IMPORTED_MODULE_1__providers_auth_guard_service__["a" /* AuthGuardService */]], canLoad: [__WEBPACK_IMPORTED_MODULE_1__providers_auth_guard_service__["a" /* AuthGuardService */]] },
            { path: 'reports', loadChildren: function() { return __webpack_require__.e/* import() */(6).then(__webpack_require__.bind(null, 1349))  .then( function(module) { return module['ReportsModule']; } ); }, canActivate: [__WEBPACK_IMPORTED_MODULE_1__providers_auth_guard_service__["a" /* AuthGuardService */]], canLoad: [__WEBPACK_IMPORTED_MODULE_1__providers_auth_guard_service__["a" /* AuthGuardService */]] },
            { path: 'customers', loadChildren: function() { return __webpack_require__.e/* import() */(7).then(__webpack_require__.bind(null, 1350))  .then( function(module) { return module['CustomersModule']; } ); }, canActivate: [__WEBPACK_IMPORTED_MODULE_1__providers_auth_guard_service__["a" /* AuthGuardService */]], canLoad: [__WEBPACK_IMPORTED_MODULE_1__providers_auth_guard_service__["a" /* AuthGuardService */]] },
            { path: 'products', loadChildren: function() { return __webpack_require__.e/* import() */(14).then(__webpack_require__.bind(null, 1351))  .then( function(module) { return module['ProductsModule']; } ); }, canActivate: [__WEBPACK_IMPORTED_MODULE_1__providers_auth_guard_service__["a" /* AuthGuardService */]], canLoad: [__WEBPACK_IMPORTED_MODULE_1__providers_auth_guard_service__["a" /* AuthGuardService */]] },
            { path: 'inventory', loadChildren: function() { return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, 1352))  .then( function(module) { return module['InventoryModule']; } ); }, canLoad: [__WEBPACK_IMPORTED_MODULE_1__providers_auth_guard_service__["a" /* AuthGuardService */]] },
            { path: 'categories', loadChildren: function() { return __webpack_require__.e/* import() */(10).then(__webpack_require__.bind(null, 1353))  .then( function(module) { return module['CategoriesModule']; } ); }, canActivate: [__WEBPACK_IMPORTED_MODULE_1__providers_auth_guard_service__["a" /* AuthGuardService */]], canLoad: [__WEBPACK_IMPORTED_MODULE_1__providers_auth_guard_service__["a" /* AuthGuardService */]] },
            { path: 'attributes', loadChildren: function() { return __webpack_require__.e/* import() */(11).then(__webpack_require__.bind(null, 1354))  .then( function(module) { return module['AttributesModule']; } ); }, canActivate: [__WEBPACK_IMPORTED_MODULE_1__providers_auth_guard_service__["a" /* AuthGuardService */]], canLoad: [__WEBPACK_IMPORTED_MODULE_1__providers_auth_guard_service__["a" /* AuthGuardService */]] },
            { path: 'branding', loadChildren: function() { return __webpack_require__.e/* import() */(19).then(__webpack_require__.bind(null, 1355))  .then( function(module) { return module['BrandingModule']; } ); }, canActivate: [__WEBPACK_IMPORTED_MODULE_1__providers_auth_guard_service__["a" /* AuthGuardService */]], canLoad: [__WEBPACK_IMPORTED_MODULE_1__providers_auth_guard_service__["a" /* AuthGuardService */]] },
            { path: 'ecommerce', loadChildren: function() { return __webpack_require__.e/* import() */(21).then(__webpack_require__.bind(null, 1356))  .then( function(module) { return module['ECommerceModule']; } ); }, canActivate: [__WEBPACK_IMPORTED_MODULE_1__providers_auth_guard_service__["a" /* AuthGuardService */]], canLoad: [__WEBPACK_IMPORTED_MODULE_1__providers_auth_guard_service__["a" /* AuthGuardService */]] },
            { path: 'form', loadChildren: function() { return __webpack_require__.e/* import() */(15).then(__webpack_require__.bind(null, 1357))  .then( function(module) { return module['MyFormsModule']; } ); }, canActivate: [__WEBPACK_IMPORTED_MODULE_1__providers_auth_guard_service__["a" /* AuthGuardService */]], canLoad: [__WEBPACK_IMPORTED_MODULE_1__providers_auth_guard_service__["a" /* AuthGuardService */]] },
            { path: 'page', loadChildren: function() { return __webpack_require__.e/* import() */(18).then(__webpack_require__.bind(null, 1358))  .then( function(module) { return module['PagesModule']; } ); }, canActivate: [__WEBPACK_IMPORTED_MODULE_1__providers_auth_guard_service__["a" /* AuthGuardService */]], canLoad: [__WEBPACK_IMPORTED_MODULE_1__providers_auth_guard_service__["a" /* AuthGuardService */]] },
            { path: 'pglayout', loadChildren: function() { return __webpack_require__.e/* import() */(23).then(__webpack_require__.bind(null, 1359))  .then( function(module) { return module['PageLayoutsModule']; } ); }, canActivate: [__WEBPACK_IMPORTED_MODULE_1__providers_auth_guard_service__["a" /* AuthGuardService */]], canLoad: [__WEBPACK_IMPORTED_MODULE_1__providers_auth_guard_service__["a" /* AuthGuardService */]] },
            { path: 'chart', loadChildren: function() { return __webpack_require__.e/* import() */(16).then(__webpack_require__.bind(null, 1360))  .then( function(module) { return module['ChartsModule']; } ); }, canActivate: [__WEBPACK_IMPORTED_MODULE_1__providers_auth_guard_service__["a" /* AuthGuardService */]], canLoad: [__WEBPACK_IMPORTED_MODULE_1__providers_auth_guard_service__["a" /* AuthGuardService */]] },
            { path: 'table', loadChildren: function() { return __webpack_require__.e/* import() */(22).then(__webpack_require__.bind(null, 1361))  .then( function(module) { return module['MyTablesModule']; } ); }, canActivate: [__WEBPACK_IMPORTED_MODULE_1__providers_auth_guard_service__["a" /* AuthGuardService */]], canLoad: [__WEBPACK_IMPORTED_MODULE_1__providers_auth_guard_service__["a" /* AuthGuardService */]] },
            { path: 'ui', loadChildren: function() { return __webpack_require__.e/* import() */(8).then(__webpack_require__.bind(null, 1362))  .then( function(module) { return module['UIModule']; } ); }, canActivate: [__WEBPACK_IMPORTED_MODULE_1__providers_auth_guard_service__["a" /* AuthGuardService */]], canLoad: [__WEBPACK_IMPORTED_MODULE_1__providers_auth_guard_service__["a" /* AuthGuardService */]] },
        ]
    }
];
var LayoutRoutingModule = __WEBPACK_IMPORTED_MODULE_0__angular_router__["g" /* RouterModule */].forChild(routes);


/***/ })

},[699]);


// WEBPACK FOOTER //
// js/main.d0c9646e9f30ac4d97b4.js